import React, { useState, useEffect, useRef, useMemo, useCallback, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import ReactSelect from 'react-select';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from "react-datepicker";
import enGB from 'date-fns/locale/en-GB';
import { useTranslation } from 'react-i18next';
import DocumentService from '../../Services/documents.service';
import UserService from '../../Services/user.service';
import PuffLoader from "react-spinners/PuffLoader";
import '../../pages/Document/Document.scss';
import './JournalEntry.css';
import backIcon from '../../assests/images/left-arrow.png';
import calendarIcon from '../../assests/images/calendar.png';
import EnumsService from '../../Services/enums.service';
import CustomDeleteConfirmationModal from '../../Components/CustomDeleteConfirmationModal/CustomDeleteConfirmationModal.js'
import { ToastContainer, toast } from "react-toastify";
import Swal from 'sweetalert2'; // Modern modal library
import MissingAccountCardsAlert from '../../Components/MissingAccountCardsAlert/MissingAccountCardsAlert';
import InactiveClientAlert from '../../Components/InactiveClientAlert/InactiveClientAlert';
import DownloadIcon from "../../assests/images/downloadIcon.png";
import NoDocumentsPdf from "../../assests/pdf/NoDocument.pdf";
import { useSignalR } from '../../Contexts/signalR';
import SignaturePad from 'react-signature-canvas';
import ClientDocumentCountService from '../../Services/ClientDocumentCount.service';
import saveIcon from "../../assests/images/save.png";
import cancelIcon from "../../assests/images/cancel.png";
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import ClientService from '../../Services/client.service';
import addIcon from "../../assests/images/plusO.png";
import loadingAnimation from "../../assests/images/Animation.gif";
import DraggableModal from '../../Components/DraggableModal/DraggableModal.js';
import ImportManifestEntryModalIcon from '../../assests/images/Icons/importManifest.svg';
import DuplicateEntriesModal from '../../Components/DuplicateEntriesModal/DuplicateEntriesModal.jsx';
import SaveIcon from '@mui/icons-material/Save'; // Save icon
import SubAccountantService from '../../Services/subAccountant.service';
import ClearIcon from '@mui/icons-material/Clear';
// MUI imports
import { Edit as EditIcon, Delete as DeleteIcon, Search as SearchIcon } from '@mui/icons-material';
import {
    Button, Dialog, DialogTitle, DialogContent, Box, DialogActions, Typography, TextField, Checkbox,
    InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper,
    ToggleButton, ToggleButtonGroup, CircularProgress, Tooltip, FormControl, Select, MenuItem
} from '@mui/material';
import dayjs, { Dayjs } from 'dayjs';
import EditModal from '../../Components/EditModal/EditModal.js';
import CustomMonthDatePicker from '../../Components/Widgets/CustomDates/CustomMonthDatePicker/CustomMonthDatePicker.js';
import { beautifyNumber } from '../../Utils/FormatNumber';
import DateInput from '../../Components/DateInput/DateInput.js';
import Constants from '../../assests/Constants/constants';
import useCaseSystemAccountSettings from '../../hooks/useCaseSystemAccountSettings';
import styled from '@mui/system/styled';
import zIndex from '@mui/material/styles/zIndex';
import UpperPanelDetails from '../../Components/Widgets/UpperPanelDetails/UpperPanelDetails.jsx';
import JournalEntryDataGrid from '../../Components/JournalEntryies/SubComponents/JournalEntryDataGrid.jsx';
import DocumentKpiCards from '../../Components/Document/SubComponents/DocumentKpiCards.jsx';
import JournalEntryDraggableDialog from '../../Components/JournalEntryies/SubComponents/JournalEntryDraggableDialog.jsx';
import JournalEntryTypeFilter from '../../Components/JournalEntryies/SubComponents/JournalEntryTypeFilter.jsx';
import { calculateVatAmount } from '../../Utils/GetVatValue';
import FilterMonthYearPicker from '../../Components/Widgets/CustomDates/FilterMonthYearPicker/FilterMonthYearPicker.jsx';
import headerStyles from '../../Components/ClientDetails/SubComponents/ClientDetailsHeader/HeaderToolbar.module.scss';
import { PermissionsContext } from '../../Contexts/Permissions';
import { NavHistoryContext } from '../../Contexts/NavHistoryContext';
import { validateDocumentBeforeProcessing, validatePaymentAcceptanceItems } from '../../Utils/documentValidation'
import { canProcessDocumentStatus } from '../../Utils/helpers.js';
import ChooseAsset from '../../Components/Widgets/ChooseAsset/ChooseAsset.js';
import AssetService from '../../Services/assets.service';
import ReportsService from '../../Services/reports.service';
import AddAssetGroup from '../../Components/Assets/SubComponents/AddAssetGroup.js';
import AssetFoundDialog from '../../Components/Widgets/AssetFoundDialog/AssetFoundDialog.js';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext';
import NavigationButton from '../../Components/NavigationButton/NavigationButton.jsx';
import ProjectsService from '../../Services/projects.service.js';

import SelectDocumentOptionDialog from '../../Components/Widgets/SelectDocumentOptionDialog/SelectDocumentOptionDialog';
import { splitSelectedRows } from '../../Components/Widgets/SelectDocumentOptionDialog/rowSelectors';
import BulkEditModal from '../../Components/PrimaryBulkActionsToolbar/BulkEditModal';
import { useClientNavigation } from '../../hooks/useClientNavigation.js';   // adjust the path
import KeyboardShortcuts from '../../Components/KeyboardShortcuts/KeyboardShortcuts.jsx';
import { fetchJournalEntryPageData, setDocuments as setJournalEntryPageDocuments } from '../../store/reducers/journalEntryPageSlice';
import { fetchDocumentEnums, selectDocumentEnums } from '../../store/reducers/documentEnumsSlice';
import ImportManifestEntryModal from '../../Components/JournalEntryies/SubComponents/index.jsx';
import JournalEntryTemplatesModal from '../../Components/JournalEntryies/SubComponents/JournalEntryTemplatesModal.jsx';
import JournalDocumentationModal from '../../Components/Document/SubComponents/JournalDocumentationModal.jsx';
import VatClosingJournalModal from '../../Components/JournalEntryies/SubComponents/VatClosingJournalModal.jsx';
import PayrollJournalModal from '../../Components/JournalEntryies/SubComponents/PayrollJournalModal.jsx';
import ZReportImportModal from '../../Components/JournalEntryies/SubComponents/ZReportImportModal.jsx';
import { JOURNAL_ENTRY_TYPE_OPTIONS } from '../../assests/Constants/journalEntryTypes';
import { PDFDocument } from 'pdf-lib';
import * as XLSX from 'xlsx';
import TableChartIcon from '@mui/icons-material/TableChart';

const StyledDialogTitle = styled(DialogTitle)({
    fontSize: '1.8rem',
    fontWeight: 'bold',
    textAlign: 'center',
    color: '#025366',
});

const StyledDialogContent = styled(DialogContent)({
    textAlign: 'center',
    padding: '20px 30px',
});

const StyledDialogActions = styled(DialogActions)({
    justifyContent: 'center',
    paddingBottom: '20px',
});

const StyledButton = styled(Button)({
    margin: '0 8px',
    padding: '10px 20px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#fff',
    backgroundColor: '#E57C22',
    '&:hover': {
        backgroundColor: '#d9731a',
    },
});


const BpIcon = styled('span')(({ theme }) => ({
    borderRadius: 3,
    width: 16,
    height: 16,
    boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
    backgroundColor: '#f5f8fa',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
    '.Mui-focusVisible &': {
        outline: '2px auto rgba(19,124,189,.6)',
        outlineOffset: 2,
    },
    'input:hover ~ &': {
        backgroundColor: '#ebf1f5',
        ...theme.applyStyles('dark', {
            backgroundColor: '#30404d',
        }),
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background: 'rgba(206,217,224,.5)',
        ...theme.applyStyles('dark', {
            background: 'rgba(57,75,89,.5)',
        }),
    },
    ...theme.applyStyles('dark', {
        boxShadow: '0 0 0 1px rgb(16 22 26 / 40%)',
        backgroundColor: '#394b59',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))',
    }),
}));

const BpCheckedIcon = styled(BpIcon)({
    backgroundColor: '#137cbd',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&::before': {
        display: 'block',
        width: 16,
        height: 16,
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
            " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
            "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: '#106ba3',
    },
});

// Inspired by blueprintjs
function BpCheckbox(props) {
    return (
        <Checkbox
            sx={{ '&:hover': { bgcolor: 'transparent' } }}
            disableRipple
            color="default"
            checkedIcon={<BpCheckedIcon />}
            icon={<BpIcon />}
            inputProps={{ 'aria-label': 'Checkbox demo' }}
            {...props}
        />
    );
}

const OptionButton = styled(Button)({
    margin: '10px 8px',
    padding: '12px 25px',
    fontSize: '1.1rem',
    textTransform: 'none',
    color: '#025366',
    backgroundColor: '#f5f5f5',
    border: '1px solid #E57C22',
    width: 'auto',  // Allows the button to shrink when there are many buttons
    maxWidth: '200px',  // Set a maximum width to ensure consistency
    flexGrow: 1,  // Allows buttons to fill available space equally
    '&:hover': {
        backgroundColor: '#E57C22',
        color: '#fff',
    },
});

const ActionButton = styled(Button)({
    backgroundColor: '#304FFF', // Consistent background with other elements
    borderRadius: 4, // Same border-radius as MUI TextField and Switch
    color: 'white',
    height: '55px', // Same height as other input elements
    padding: '0 16px', // Consistent padding
    fontSize: '0.875rem', // Matching font size with TextField
    textTransform: 'none',
    boxSizing: 'border-box',
    '&:hover': {
        backgroundColor: '#F9AA2A', // Slightly darker on hover
    },
    '&:disabled': {
        backgroundColor: '#E0E0E0',
        color: '#BDBDBD',
    },
});
setDefaultLocale('en-GB'); // Set the default locale to use it
const headers = ['Dessert (100g serving)', 'Calories', 'Fat (g)'];

const rows = [
    { name: 'Frozen yoghurt', calories: 159, fat: 6.0 },

];





function JournalEntry() {
    const navigate = useNavigate();
    const { i18n, t } = useTranslation();

    const [modalVisible, setModalVisible] = useState(false);
    //invoice modal for both invoices
    const [chooseInvoiceModal, setChooseInvoiceModal] = useState(false);
    const [invoiceModalVisible, setInvoiceModalVisible] = useState(false);
    const [invoiceTypeInModal, setInvoiceTypeInModal] = useState(false);
    const [allowAllSelect, setAllowAllSelect] = useState(false);



    const [signatureReferenceInvoiceModalVisible, setSignatureReferenceInvoiceModalVisible] = useState(false);
    const [currentInvoiceCreatingType, setCurrentInvoiceCreatingType] = useState('');
    const [documentDate, setDocumentDate] = useState(new Date());
    const [reportingMonthDateCreate, setReportingMonthDateCreate] = useState(new Date());
    const [documentCost, setDocumentCost] = useState('');
    const [documentVat, setDocumentVat] = useState(100);
    const [documentReference, setDocumentReference] = useState('');
    const [sortCodeId, setCodeId] = useState('');
    const [accountCodeName, setAccountCodeName] = useState('');
    const [companyId, setCompanyId] = useState('');
    const [accountCodeId, setAccountCodeId] = useState('');
    const [description, setDescription] = useState('');
    const [documents, setDocuments] = useState([]);
    const [errorMessage, setErrorMessage] = useState('');
    const [okMessage, setOkMessage] = useState('');
    const [user, setUser] = useState(null);
    const [token, setToken] = useState('');
    const [client, setClient] = useState(null);
    const { settings: caseSystemSettings } = useCaseSystemAccountSettings(client?.caseId, token);
    const [type, setType] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [showOnlyUnprocessed, setShowOnlyUnprocessed] = useState(false);
    const [gridFilteredData, setGridFilteredData] = useState(null);
    const [focused, setFocused] = useState(false);
    const [alignment, setAlignment] = useState('web');
    const dataGridRef = useRef();
    const modalCreateDocumentRef = useRef(); // Reference to the modal content
    const modalInvoiceCreateDocumentRef = useRef();
    const signatureReferenceInvoiceModalVisibleRef = useRef();
    const fetchUserDataInFlightRef = useRef(false);
    const docFetchInFlightRef = useRef(false);
    const initialLoadDoneRef = useRef(false);
    const prevIsRangeRef = useRef(null);
    const prevUseRegistrationMonthRef = useRef(null);
    const enumsFetchInFlightRef = useRef(false);
    const dispatch = useDispatch();
    const journalEntryPage = useSelector((state) => state.journalEntryPageSlice || {});
    const rawDocumentsFromRedux = journalEntryPage.documents || [];
    const pageLoading = journalEntryPage.loading || false;
    const creditDebitSumFromRedux = journalEntryPage.creditDebitSum;
    const missingCardsFromRedux = journalEntryPage.missingCards || [];
    const denseTableCreditDebitHeaderFromRedux = journalEntryPage.denseTableCreditDebitHeader;
    const denseTableCreditDebitRowsFromRedux = journalEntryPage.denseTableCreditDebitRows;
    const documentEnumsFromRedux = useSelector((state) => selectDocumentEnums(state, client?.caseId));
    const data = useMemo(() => rawDocumentsFromRedux.map((d) => ({
        ...d,
        vatAmount: calculateVatAmount(d?.amount, d.vat, d.documentDate),
        netAmount: (d.amount || 0) - (calculateVatAmount(d?.amount, d.vat, d.documentDate) || 0)
    })), [rawDocumentsFromRedux]);
    const isInitialLoad = (rawDocumentsFromRedux?.length ?? 0) === 0;
    const [sortCodeIdOptions, setSortCodeIdOptions] = useState([]);
    const [accountCardOptions, setAccountCardOptions] = useState([]);
    const [accountCardEditDownloadOptions, setAccountCardEditDownloadOptions] = useState([]);
    const [clientItems, setClientItems] = useState([]);
    const [formattedPalCodeOptions, setFormattedPalCodeOptions] = useState([]);
    const [palCode, setPalCode] = useState('');

    const [creditAccountOptions, setCreditAccountOptions] = useState([]);
    const [debitAccountOptions, setDebitAccountOptions] = useState([]);
    const [creditAccountOption, setCreditAccountOption] = useState('');
    const [debitAccountOption, setDebitAccountOption] = useState('');
    const location = useLocation();
    const [editingRow, setEditingRow] = useState(null);
    const [editedItem, setEditedItem] = useState({});
    const [oldAccountName, setOldAccountName] = useState({});
    const [oldAccountCaseId, setOldAccountCaseId] = useState({});
    const [oldAccountCardId, setOldAccountCardId] = useState({});
    const [editedPopupItem, setEditedPopupItem] = useState(true);
    const [editedAddAccountCard, setEditedAddAccountCard] = useState(false);
    const [originalAccountCardId, setOriginalAccountCardId] = useState('');
    const [sortDate, setSortDate] = useState(() => {
        const storedDateString = localStorage.getItem('Date');
        return storedDateString ? new Date(storedDateString) : new Date();
    });
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [itemIdToDelete, setItemIdToDelete] = useState(null);
    const [showImportManifestModal, setShowImportManifestModal] = useState(false);
    const [showDuplicatesModal, setShowDuplicatesModal] = useState(false);
    const [showJournalTemplatesModal, setShowJournalTemplatesModal] = useState(false);
    const [showVatClosingModal, setShowVatClosingModal] = useState(false);
    const [showPayrollModal, setShowPayrollModal] = useState(false);
    const [showZReportModal, setShowZReportModal] = useState(false);
    const [localLoading, setLocalLoading] = useState(false);
    const loading = pageLoading || localLoading;
    /** Full-page overlay: only when no data yet (initial load) or local operation. Not shown on background refresh when Redux already has data. */
    const showPageLoadingOverlay = localLoading || (pageLoading && isInitialLoad);
    const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem('language') || 'he');
    const [currentIndex, setCurrentIndex] = useState(-1);
    const { goBack } = useContext(NavHistoryContext);
    const { setMenuProps } = useHamburgerMenu();
    useEffect(() => {
        setMenuProps({ client });
    }, [client, setMenuProps]);

    const [startDate, setStartDate] = useState(() => {
        const storedDateString = localStorage.getItem('StartDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    });; // Start date for range
    const [endDate, setEndDate] = useState(() => {
        const storedDateString = localStorage.getItem('EndDate');
        return storedDateString ? new Date(storedDateString) : new Date();
    });; // End date for range

    
    const [isRange, setIsRange] = useState(() => {
        const storedIsRange = localStorage.getItem('IsRange');
        return storedIsRange === "true";
    });;
    const [useRegistrationMonth, setUseRegistrationMonth] = useState(() => {
        const storedUseRegistrationMonth = localStorage.getItem('UseRegistrationMonth');
        return storedUseRegistrationMonth === "true";
    });
    const [showDownloadModal, setShowDownloadModal] = useState(false);
    const [downloadStartDate, setDownloadStartDate] = useState(null); // Start date for range
    const [downloadEndDate, setDownloadEndDate] = useState(null);
    const [downloadAmount, setDownloadAmount] = useState();
    const [downloadAccountCodeId, setDownloadAccountCodeId] = useState([]);
    const [isDateEnabled, setIsDateEnabled] = useState(false);
    const { documentUpdate } = useSignalR();
    const [statusCheck, setStatusCheck] = useState(false);
    const [isClosedReportingMonth, setIsClosedReportingMonth] = useState(false);
    const isClosedReportingMonthFromRedux = journalEntryPage.isClosedReportingMonth;
    const isClosedReportingMonthDisplay = isClosedReportingMonthFromRedux ?? isClosedReportingMonth;
    const [isFirstUserFetched, setIsFirstUserFetched] = useState(false);
    const [actionType, setActionType] = useState('delete');
    const [selectedJournalEntryTypes, setSelectedJournalEntryTypes] = useState([]);

    const compareProjectCodes = useCallback(
        (a, b) => String(a?.code ?? '').localeCompare(String(b?.code ?? ''), undefined, { numeric: true }),
        []
    );
    const [byProjectsFilterActive, setByProjectsFilterActive] = useState(false);
    const [segmentationProjects, setSegmentationProjects] = useState([]);
    const [loadingSegmentations, setLoadingSegmentations] = useState(false);
    const [selectedFromSegmentation, setSelectedFromSegmentation] = useState(null);
    const [selectedToSegmentation, setSelectedToSegmentation] = useState(null);
    const [journalEntryTypeDropdownOpen, setJournalEntryTypeDropdownOpen] = useState(false);
    // invoice Details // 
    const sigPad = useRef({});
    const [invoiceDescription, setInvoiceDescription] = useState('');
    const [invoiceReference, setInvoiceReference] = useState('');
    const [invoiceClientName, setInvoiceClientName] = useState('');
    const [invoiceClientCaseId, setInvoiceClientCaseId] = useState('');
    const [invoiceClientLocation, setInvoiceClientLocation] = useState('');
    const [invoiceClientEmail, setInvoiceClientEmail] = useState('');
    const [invoiceClientPhoneNumber, setInvoiceClientPhoneNumber] = useState('');
    const [invoiceSignature, setInvoiceSignature] = useState('');
    const [invoiceAccountCodeId, setInvoiceAccountCodeId] = useState('');
    const [invoiceItems, setInvoiceItems] = useState([]);
    const [invoiceDate, setInvoiceDate] = useState(new Date());
    const [addNewItem, setAddNewItem] = useState(false);
    const [addNewAccountCard, setAddNewAccountCard] = useState(false);
    const [addNewAccountCardDocument, setAddNewAccountCardDocument] = useState(false);
    const [addNewSignatureReference, setAddNewSignatureReference] = useState(false);
    const [newItems, setNewItems] = useState([]); // To store new items
    const [addItemFlags, setAddItemFlags] = useState([]); // Array of booleans to track add new item mode per index
    const [priceIncludingVAT, setPriceIncludingVAT] = useState(false);
    const [sortConfig, setSortConfig] = useState({ key: 'uploadNumber', direction: 'descending', type: 'number' });
    const [open, setOpen] = useState(false);
    const [selectedDate, setSelectedDate] = useState(dayjs(sortDate));
    const [autoFilling, setAutoFilling] = useState(true);
    const [fade, setFade] = useState(false);
    const [denseTableHeader, setDenseTableHeader] = useState([]);
    const [denseTableRows, setDenseTableRows] = useState([]);
    const [denseTableCreditDebitHeader, setDenseTableCreditDebitHeader] = useState([]);
    const [denseTableCreditDebitRows, setDenseTableCreditDebitRows] = useState([]);
    const [missingAccountCards, setMissingAccountCards] = useState([]);
    const [complexDepositsChecked, setComplexDepositsChecked] = useState(false);
    const [debitCreditSum, setDebitCreditSum] = useState(0);
    const [creditSum, setCreditSum] = useState(0);
    const [debitSum, setDebitSum] = useState(0);
    const handleSignatureChange = () => {
        if (sigPad.current) {
            const signatureImage = sigPad.current.getTrimmedCanvas().toDataURL('image/png');
            setInvoiceSignature(signatureImage);
        }
    };
    // const [toastPosition, setToastPosition] = useState('')
    const [selectedRows, setSelectedRows] = useState([]);
    const [bulkEditOpen, setBulkEditOpen] = useState(false);
    const [allSelected, setAllSelected] = useState(false);
    const [openOptions, setOpenOptions] = useState(false);
    const [isAllSelected, setIsAllSelected] = useState(false);
    const [addNewJournalEntry, setAddNewJournalEntry] = useState(false);
    const [isEditJournalEntryTypeModalOpen, setIsEditJournalEntryTypeModalOpen] = useState(false);
    const [selectedJournalEntryTypeForBulk, setSelectedJournalEntryTypeForBulk] = useState(0);
    const [cardIdOption, setCardIdOption] = useState('');
    const [addItem, setAddItem] = useState({
        accountCodeName: '',
        accountCaseId: '',         // Account case ID
        accountCodeId: '',         // Account case ID
        reference: '',             // Reference field
        description: '',           // Description of the entry
        uploadDate: new Date(),            // Upload date (formatted)
        documentDate: new Date(),          // Document date (formatted)
        amount: '',                 // Amount (numeric)
        vat: 0,                    // VAT percentage
        creditAccount: '',         // Credit account
        debitAccount: '',          // Debit account
        sortCodeId: '',            // Sort code ID
        processed: false,          // Processed/unprocessed status
    });
    const [currentRowData, setCurrentRowData] = useState({});
    const [openInlineEditModal, setOpenInlineEditModal] = useState(false);
    const [isAddMode, setIsAddMode] = useState(false);
    const { userTypeContext, permissionsState, clientPermissionsState } = useContext(PermissionsContext);
    const hideStatusBadge = clientPermissionsState?.CantSeeStatusDocuments &&
        userTypeContext?.toString() === Constants.UserType.Client;
    const canProcessStatus = canProcessDocumentStatus(userTypeContext, permissionsState, hideStatusBadge);


    const handleDialogClose = () => {
        setOpenInlineEditModal(false);
        setCurrentRowData(null);
        setIsAddMode(false);
        setAddNewJournalEntry(false);
    };
    
    const direction = i18n.dir();

    const handleDialogSave = (formData) => {

        if (isAddMode) {
            handleNormalSave(formData);
        } else {
            handleUpdate(formData);
        }
    };


    const handleOpenDialog = (formData, isAddMode) => {
        setCurrentRowData(formData);
        setIsAddMode(isAddMode);
        setOpenInlineEditModal(true);
    }

    // Removed useEffect for addNewJournalEntry - now handled by separate buttons
    // The inline grid button handles its own state
    // The top button opens the dialog directly

    
    const setOpenOption = () => setOpenOptions(true);
    const closeOptions = () => {
        setOpenOptions(false);
        handleDeselect(selectedRows);
        setSelectedRows([]); // Unselect all rows
        setIsAllSelected(false); // Uncheck the "Select all" checkbox
        setComplexDepositsChecked(false);
    };
    const isFormValid = Boolean(addItem.amount);

    const handleInputChange = (field, value) => {

        if (field === 'accountCodeName') {
            setAddItem(prevState => ({
                ...prevState,
                accountCodeName: value.value,
                accountCaseId: value.accountCaseId,
                accountCodeId: value.value1
            }));

        } else {
            setAddItem(prevState => ({
                ...prevState,
                [field]: value
            }));
        }


    };

    const isSelected = (id) => selectedRows.indexOf(id) !== -1;



    const handleSelectRow = (event, item) => {
        const selectedIndex = selectedRows.findIndex(selected => selected.id === item.id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedRows, item);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedRows.slice(1));
        } else if (selectedIndex === selectedRows.length - 1) {
            newSelected = newSelected.concat(selectedRows.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedRows.slice(0, selectedIndex),
                selectedRows.slice(selectedIndex + 1),
            );
        }

        setSelectedRows(newSelected);
    };


    const handleSelectAllClick = (event) => {
        const checked = event.target.checked;

        setIsAllSelected(checked);

        if (checked) {
            // Filter items based on the condition before selecting
            const newSelecteds = filteredAndSortedData
                .filter((item) => {
                    // Apply the same condition used for displaying checkboxes
                    const condition = client?.accountManagement === Constants.AccountManagementOptions[0].name
                        ? item.sortCodeId && item.creditAccount && item.debitAccount
                        : item.sortCodeId;
                    return condition;
                })
                .map((item) => item.id);
            setSelectedRows(newSelecteds);
            setAllSelected(true);
        } else {
            setSelectedRows([]);
            setAllSelected(false);
        }
    };

    // helper ────────────────────────────────────────────────────────────────
    const safeFetch = async (promise, {
        successKey,               // i18n success key
        defaultErrorKey,          // i18n fallback error key
        extraErrorHandler = null, // optional fn(errText) → string (translated message)
    }) => {
        try {
            const res = await promise;

            if (res?.ok || res === true) {          // some calls return boolean
                toast.success(t(successKey));
                return true;
            }

            // Response returned but not OK
            let errText = '';
            try {
                errText = typeof res.text === 'function' ? await res.text() : res?.message || '';
            } catch { /* ignore */ }

            const finalMsg =
                extraErrorHandler?.(errText) ||
                t(defaultErrorKey, { errorText: errText || t('UnknownServerError') });

            toast.error(finalMsg);
        } catch (networkErr) {
            // Fetch/network/JS error
            toast.error(networkErr?.message || t('generalError'));
        }
        return false;
    };

    // main ──────────────────────────────────────────────────────────────────
    const handleOptionSelect = async option => {
        const { locked, unlocked } = splitInfo;

        /* ---------- Early-exit guards ---------- */
        if (
            (option === 'locked' && !unlocked.length) ||
            (option === 'storno' && !locked.length) ||
            ((option === 'done' || option === 'notDone') && !unlocked.length)
        ) {
            toast.info(t('NothingToProcess'));
            closeOptions();
            return;
        }

        setLocalLoading(true);
        let refreshNeeded = false;

        try {
            switch (option) {
                /* ───────── processed / unprocessed ───────── */
                case 'done':
                    handleDoneIdsClick(unlocked);
                    break;

                case 'notDone':
                    handleNotDoneIdsClick(unlocked);
                    break;

                /* ───────── lock ───────── */
                case 'locked':
                    refreshNeeded = await safeFetch(
                        DocumentService.LockDocumentsByTypeAndIds(
                            client.caseId,
                            client.accountantId,
                            unlocked,
                            token
                        ),
                        {
                            successKey: 'DocumentsLocked',
                            defaultErrorKey: 'FailedToLockDocuments',
                            extraErrorHandler: errText =>
                                errText.toLowerCase().includes('not processed')
                                    ? t('SomeRowsNotProcessed')
                                    : null,
                        }
                    );
                    break;

                /* ───────── storno ───────── */
                case 'storno':
                    DocumentService.CreateStornoEntries(locked, client.caseId, token);
                    refreshNeeded = true;
                    break;

                default:
                    break;
            }

            /* ---------- Refresh grid once if anything succeeded ---------- */
            if (refreshNeeded) {
                if (isRange) {
                    await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate));
                } else {
                    await fetchDocuments(new Date(sortDate));
                }
            }
        } finally {
            setLocalLoading(false);
            closeOptions();
        }
    };



    useEffect(() => {
        if (currentIndex != -1) {
            setFade(true);
            const timer = setTimeout(() => setFade(false), 500);
            return () => clearTimeout(timer);
        }
    }, [currentIndex]);






    // Update an existing item
    const handleItemChange = (index, field, value) => {
        if (addItemFlags[index]) {
            setNewItems(prevNewItems => {
                const newItemsCopy = [...prevNewItems];
                newItemsCopy[index] = {
                    ...newItemsCopy[index],
                    [field]: value,
                    caseId: client.caseId // Assuming caseId is available here
                };
                return newItemsCopy;
            });
        }
        if (field === "discount" && (parseInt(value) > 100 || parseInt(value) < 0)) {
            return;
        }
        setInvoiceItems(prevItems => {
            const updatedItems = prevItems.map((item, idx) => idx === index ? { ...item, [field]: value } : item);
            return updatedItems;
        });
    };


    // Remove an item
    const handleRemoveItem = (index) => {
        const newItems = invoiceItems.filter((_, idx) => idx !== index);
        setInvoiceItems(newItems);
    };

    const handleListItemClick = (month) => {
        const newDate = sortDate.month(month - 1);  // month is 0-indexed in JavaScript
        setSelectedDate(newDate);
        setSortDate(newDate);
        setOpen(false);
    };

    const CloseReportingMonth = async (status) => {
        setLocalLoading(true);
        try {
            const response = await ClientService.UpdateReportingMonth(client.caseId, sortDate, status, token);
            if (response.ok) {
                toast.success(
                    status ? t('MonthReportClosedSuccess') : t('MonthReportOpenedSuccess'));
                setIsClosedReportingMonth(status);
                if (!isRange) fetchPageData(new Date(sortDate), new Date(sortDate), false);
                else fetchPageData(new Date(startDate), new Date(endDate), true);
            } else {
                const errorText = await response.text();
                console.error(t('MonthReportNotClosed'), errorText);
                toast.error(
                    status ? `${t('MonthReportNotClosed')}: ${errorText}` : `${t('MonthReportNotOpened')}: ${errorText}`,
                );
            }
        } catch (error) {
            console.error(t('MonthReportNotClosed'), error);
            toast.error(status ? `${t('MonthReportNotClosed')}: ${error}` : `${t('MonthReportNotOpened')}: ${error}`,
            );
        } finally {
            setLocalLoading(false); // Stop loading regardless of the outcome
            setIsModalVisible(false)
        }
    };

    const handleDeleteClick = (itemId) => {
        setItemIdToDelete(itemId);
        setIsModalVisible(true);
    };

    const handleEditDeleteClick = (itemId) => {
        setEditedPopupItem(false);
        setEditedItem({});
        handleDeleteClick(itemId);
    };

    const [saleEquipment, setSaleEquipment] = useState(false);
    const [dateForAsset, setDateForAsset] = useState(new Date().toISOString());
    const [clickedAsset, setClickedAsset] = useState(null);
    const [showAssetFoundDialog, setShowAssetFoundDialog] = useState(false);
    const [foundAsset, setFoundAsset] = useState(null);
    const fetchEnumsNoParams = async () => {
        await fetchEnums(user, token, client);
    };

    /** Force refetch enums (bypass cache) – use after adding account card so accountCardOptions includes the new card */
    const fetchEnumsForceRefetch = useCallback(async () => {
        await fetchEnums(user, token, client, { forceRefetch: true });
    }, [user, token, client]);

    const handleImportManifestAccountCardAdded = useCallback(async () => {
        await fetchEnums(user, token, client, { forceRefetch: true });
    }, [user, token, client]);

    const isPurchaseOfEquipment = (itemId) => {
        const item = data.find((d) => d.id === itemId);

        if (!item) return false; // If the item is not found, allow processing
        const sortCode = sortCodeIdOptions.find((option) => option.sortCodeId === item.sortCodeId);
        if (!sortCode) return false; // If the sort code is not found, allow processing


        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    };


    const isDepreciationDocument = (itemId, sortCodeId) => {
        const item = data.find((d) => d.id === itemId);
        if (!item) return false; // If the item is not found, allow processing
        setItemForAssets(item);
        setDateForAsset(item.documentDate);
        const sortCode = sortCodeIdOptions.find((option) => option.sortCodeId === sortCodeId);
        if (!sortCode) return false; // If the sort code is not found, allow processing

        const isItemUsedInAssets = assets.some(
            (asset) => asset.expenseId === itemId || asset.journalEntryId === itemId
        );


        const name = sortCode.sortCodeName?.trim().replace(/\s+/g, ' ') || "";
        const saleEquipmentRegex = /(מכירה|מכירת).*ציוד|ציוד.*(מכירה|מכירת)/;
        if (sortCode.sortCodeId === caseSystemSettings.fixedAssetSaleSortCode || saleEquipmentRegex.test(name)) {

            setSaleEquipment(true);
            return true;
        }


        setSaleEquipment(false);
        return Boolean(Constants.depreciationAssetSortCodeType[sortCode.sortCodeVatType]);
    };


    const [showChooseAsset, setShowChooseAsset] = useState(false);
    const [itemToAddToAsset, setItemToAddToAsset] = useState('');
    const [itemForAssets, setItemForAssets] = useState({});

    const handleAssetClicked = (asset, item) => {
        setItemToAddToAsset(item.id);
        setItemForAssets(item)
        setClickedAsset(asset);
        setShowChooseAsset(true);
    }

    const handleAssetClose = () => {
        setShowChooseAsset(false);
        setClickedAsset(null);
    }



    const handleDoneClick = async (itemId) => {
        if (!canProcessStatus) {
            return;
        }

        setLocalLoading(true);

        try {
            const response = await ClientDocumentCountService.removeDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleNotDoneClick = async (itemId) => {
        if (!canProcessStatus) {
            return;
        }
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentByTypeAndId(client.caseId, client.accountantId, type, itemId, token)
            if (response.ok) {
                await fetchDocumentsNotification(client, token)
                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleDoneIdsClick = async (itemIds) => {
        if (!canProcessStatus) {
            return;
        }
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.removeDocumentsByTypeAndIds(client.caseId, client.accountantId, type, itemIds, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token);
                await fetchDocuments(new Date(sortDate));

                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentsNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentsNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleNotDoneIdsClick = async (itemIds) => {
        if (!canProcessStatus) {
            return;
        }
        setLocalLoading(true);
        try {
            const response = await ClientDocumentCountService.addDocumentsByTypeAndIds(client.caseId, client.accountantId, type, itemIds, token);
            if (response.ok) {
                await fetchDocumentsNotification(client, token);
                await fetchDocuments(new Date(sortDate));

                toast.success(t('DocumentProcessed'));
            } else {
                const errorText = await response.text();
                toast.error(t('DocumentsNotProcessed', { errorText }));
            }
        } catch (error) {
            toast.error(t('DocumentsNotProcessed', { errorText: error.message }));
        }
        setLocalLoading(false);
    };

    const handleDeselect = (ids) => {
        if (dataGridRef.current) {
            dataGridRef.current.deselectRows(ids); // Call deselectRow on the ref
        }
    };
    const handleStartDateChange = async (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        localStorage.setItem('StartDate', newDate)
        setStartDate(newDate);
        if (isRange) {
            await fetchDataOnDateRangeChange(new Date(newDate), new Date(endDate));
        }
    };

    const handleEndDateChange = async (date) => {
        const endDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        localStorage.setItem('EndDate', endDate)
        setEndDate(endDate);
        if (isRange) {
            await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate));
        }
    };

    const handleDownloadStartDateChange = (date) => {
        const newDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setDownloadStartDate(newDate);
    };

    const handleDownloadEndDateChange = async (date) => {
        const endDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), 10));
        setDownloadEndDate(endDate);
    };

    const toISO = (d) => (d instanceof Date ? d.toISOString() : new Date(d).toISOString());

    async function fetchPageData(start, end, isRangeMode, options = {}) {
        const { backgroundRefresh = false } = options;
        if (docFetchInFlightRef.current) return;
        docFetchInFlightRef.current = true;
        if (!backgroundRefresh) initialLoadDoneRef.current = false;
        const startISO = toISO(start);
        const endISO = toISO(end);
        const requestKey = `${startISO}|${endISO}|${isRangeMode}|${useRegistrationMonth}`;
        try {
            await dispatch(fetchJournalEntryPageData({
                caseId: client.caseId,
                startDate: startISO,
                endDate: endISO,
                useRegistrationMonth,
                isRange: isRangeMode,
                requestKey,
                token,
                backgroundRefresh
            })).unwrap();
            initialLoadDoneRef.current = true;
        } catch (err) {
            if (!backgroundRefresh) toast.error(t('documentFetchError', { errorText: err?.message || err || '' }));
        } finally {
            docFetchInFlightRef.current = false;
        }
    }

    async function fetchDataOnDateRangeChange(startDate, endDate) {
        await fetchPageData(new Date(startDate), new Date(endDate), true);
    }

    const handleConfirm = async () => {
        if (actionType === 'delete') {
            await handleConfirmDelete();
        } else if (actionType === 'closeMonth') {
            await CloseReportingMonth(true);
        } else if (actionType === 'openMonth') {
            await CloseReportingMonth(false);
        }
    };

    const getConfirmMessage = () => {
        switch (actionType) {
            case 'closeMonth':
                return t('AreYouSureCloseMonth');
            case 'openMonth':
                return t('AreYouSureOpenMonth');
            default:
                return t('confirmDeleteMessage');

        }
    };

    const getTitleMessage = () => {
        switch (actionType) {

            case 'closeMonth':
                return t('ConfirmCloseMonth');
            case 'openMonth':
                return t('ConfirmOpenMonth');
            default:
                return t('confirmDeleteTitle');
        }
    };

    const handleConfirmDelete = async () => {
        // Perform delete operation
        setLocalLoading(true);
        setIsModalVisible(false);
        try {
            const response = await DocumentService.DeleteDocument(type, itemIdToDelete, token);
            if (response.ok) {
                if (isRange) {
                    await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate))
                }
                else
                    await fetchDocuments(new Date(sortDate));

                // Show success toast
                toast.success(t("documentDeleteSuccess"));
            } else {
                // Handle any errors or display an error toast
                const errorResponse = await response.json();
                console.error('Error deleting document:', errorResponse);

                // Show error toast
                toast.error(t("documentDeleteError"));
            }
        } catch (error) {
            console.error('Error deleting document:', error);

            // Show error toast
            toast.error(t("documentDeleteError"));
        }
        setLocalLoading(false);
    };


    // const handleEdit = (item, isPopup = true) => {
    //     setEditingRow(item.id);
    //     setEditedItem({ ...item }); // create a copy of the item for editing
    //     let statusChecked = type == "Incomes" ? client.documentIds.incomes.includes(item.id) : client.documentIds.expenses.includes(item.id);
    //     setStatusCheck(!statusChecked);
    //     setEditedPopupItem(isPopup);

    // };

    const handleEdit = (item, index, isPopup = true) => {
        setEditingRow(item.id);
        // Preserve item.docType if it exists (e.g., from cross-type duplication), otherwise use page type
        item.docType = item.docType || type;

        setEditedItem({ ...item });
        // Navigate based on the currently visible (searched/filtered) rows, not the full data set.
        const navigationData = gridFilteredData ?? filteredAndSortedData;
        const navIndex = navigationData.findIndex((row) => row.id === item.id);
        setCurrentIndex(navIndex >= 0 ? navIndex : index);
        // Use item.docType for status check if available, otherwise fall back to type
        const docTypeForStatus = item.docType || type;
        let statusChecked = docTypeForStatus === "JournalEntries"
            ? (client.documentIds?.journalEntries ?? []).includes(item.id)
            : docTypeForStatus === "Incomes"
                ? (client.documentIds?.incomes ?? []).includes(item.id)
                : (client.documentIds?.expenses ?? []).includes(item.id);
        setStatusCheck(!statusChecked);
        setEditedPopupItem(isPopup);
    };

    const handleReopenEdit = async (item, index) => {
        await fetchEnums(user, token, client);
        handleEdit(item, index);
    };


    const handlePrevious = () => {
        // Navigate within the currently visible (searched/filtered) rows, not the full data set.
        const navigationData = gridFilteredData ?? filteredAndSortedData;
        const resolvedIndex = navigationData.findIndex((row) => row.id === editedItem?.id);
        const baseIndex = resolvedIndex >= 0 ? resolvedIndex : currentIndex;
        if (baseIndex > 0) {
            const newIndex = baseIndex - 1;
            setCurrentIndex(newIndex);
            const item = navigationData[newIndex];
            // Preserve item.docType if it exists, otherwise use page type
            item.docType = item.docType || type;
            const docTypeForStatus = item.docType || type;
            let statusChecked = docTypeForStatus === "JournalEntries"
                ? (client.documentIds?.journalEntries ?? []).includes(item.id)
                : docTypeForStatus === "Incomes"
                    ? (client.documentIds?.incomes ?? []).includes(item.id)
                    : (client.documentIds?.expenses ?? []).includes(item.id);
            setStatusCheck(!statusChecked);
            setEditedItem({ ...item });

        }
    };

    const handleNext = () => {
        // Navigate within the currently visible (searched/filtered) rows, not the full data set.
        const navigationData = gridFilteredData ?? filteredAndSortedData;
        const resolvedIndex = navigationData.findIndex((row) => row.id === editedItem?.id);
        const baseIndex = resolvedIndex >= 0 ? resolvedIndex : currentIndex;
        if (baseIndex < navigationData.length - 1) {
            const newIndex = baseIndex + 1;
            setCurrentIndex(newIndex);
            const item = navigationData[newIndex];
            // Preserve item.docType if it exists, otherwise use page type
            item.docType = item.docType || type;
            const docTypeForStatus = item.docType || type;
            let statusChecked = docTypeForStatus === "JournalEntries"
                ? (client.documentIds?.journalEntries ?? []).includes(item.id)
                : docTypeForStatus === "Incomes"
                    ? (client.documentIds?.incomes ?? []).includes(item.id)
                    : (client.documentIds?.expenses ?? []).includes(item.id);
            setStatusCheck(!statusChecked);
            setEditedItem({ ...item });
        }
    };

    const handleToggleButtonChange = (event, newAlignment) => {
        setAlignment(newAlignment);
    };
    const handleChange = (field, value) => {

        const updatedValue = value;


        if (field === 'sortCodeId') {
            let depreciation = false;

            if (isDepreciationDocument(editedItem.id, value)) {
                depreciation = true;
                setItemToAddToAsset(editedItem.id);
                setShowChooseAsset(true);

            }

            if (isPurchaseOfEquipment(editedItem.id) && !depreciation) {
                if (assets) {
                    const assetFound = assets.find(
                        (asset) => asset.expenseId === editedItem.id || asset.journalEntryId === editedItem.id
                    );
                    if (assetFound) {
                        setFoundAsset(assetFound);
                        setShowAssetFoundDialog(true);
                    }
                }
            }

            if (updatedValue === '') {
                setEditedItem((prev) => ({
                    ...prev,
                    [field]: updatedValue,
                }));
                return;
            }
            const name = sortCodeIdOptions.find(
                (option) => option.sortCodeId === value
            )?.sortCodeName

            // Extract the name without the parentheses
            const nameWithoutParentheses = name.replace(/\s*\(.*?\)\s*/, '').trim();

            // Check for a number within parentheses
            const match = name.match(/\((\d+)%?/);
            let customVat = match ? parseInt(match[1], 10) : null;

            const sortCode = sortCodeIdOptions.filter(sc => sc.sortCodeId === updatedValue)[0];

            // Determine the VAT based on the name without parentheses
            const newVat = sortCode?.vat ?? 100;

            const accountCard = accountCardOptions.find(
                (item) => item.cardId === (type === 'Incomes' ? sortCode.debitAccount : sortCode.creditAccount)
            );

            const debit = accountCardOptions.find(
                (item) => item.cardId === sortCode.debitAccount
            );

            const credit = accountCardOptions.find(
                (item) => item.cardId === sortCode.creditAccount
            );

            if (value === '1') { //hova
                setEditedItem((prev) => ({
                    ...prev,
                    vat: newVat,
                    [field]: updatedValue,
                    creditAccount: null,
                    debitAccount: debit ? debit.cardId : prev?.debitAccount,

                }));
                return;
            }
            if (value === '2') { //z5ot
                setEditedItem((prev) => ({
                    ...prev,
                    vat: newVat,
                    [field]: updatedValue,
                    creditAccount: credit ? credit.cardId : prev?.creditAccount,
                    debitAccount: null,

                }));
                return;
            }


            setEditedItem((prev) => ({
                ...prev,
                vat: newVat,
                [field]: updatedValue,
                creditAccount: sortCode.creditAccount ? sortCode.creditAccount : prev.creditAccount,
                debitAccount: sortCode.debitAccount ? sortCode.debitAccount : prev.debitAccount,
            }));

        } else {
            // For fields other than sortCodeId, just update the edited item

            setEditedItem({
                ...editedItem,
                [field]: updatedValue,
            });
        }
    };


    const handleRadioChange = async (e, options = {}) => {
        if (!canProcessStatus) {
            return;
        }
        if (e.target.value?.toString() === 'done') {
            if (!options?.validationAlreadyDone) {
                const isValid = await validateDocumentBeforeProcessing(editedItem, t, client, options?.forceProcess === true);
                if (!isValid) return;
            }
            setStatusCheck(true);
        }

        else if (e.target.value?.toString() === 'notDone') {
            setStatusCheck(false);
        }

        setEditedItem({ ...editedItem, status: e.target.value });
    };

    const handleVatRadioChange = (e) => {
        setEditedItem({ ...editedItem, ["vat"]: parseFloat(e.target.value) });
    };
    const [denseTableCreditDebit, setDenseTableCreditDebit] = useState([]);




    const handleDateChange = (e, field) => {
        setEditedItem({ ...editedItem, [field]: e });
    };
    const setReportingMonthDate = async (selectedDate, field) => {
        if (!selectedDate) {
            return;
        }
        const newDate = new Date(Date.UTC(selectedDate.getFullYear(), selectedDate.getMonth(), 10));
        // const response1 = await ClientService.CheckIfMonthClosed(client.caseId, newDate, token);
        // if (response1.ok) {
        //     const isClosedReportingMonth = await response1.json();
        //     if (isClosedReportingMonth) {
        //         toast.info(t('MonthReportAlreadyClosedTryAgain'));
        //         return
        //     }
        //     else {
        //         if (modalVisible) {
        //             setReportingMonthDateCreate(newDate);
        //         }
        //         else {

        //             setEditedItem({ ...editedItem, [field]: newDate });
        //         }
        //     }
        // }
        if (modalVisible) {
            setReportingMonthDateCreate(newDate);
        }
        else {

            setEditedItem({ ...editedItem, [field]: newDate });
        }
    }

    const handleChangeNew = (selectedOption) => {
        if (selectedOption.value1 === "AddItem") {
            setCreditAccountOption("");
            setDebitAccountOption("");
            setAccountCodeName("");
            setAccountCodeId("");
            setCompanyId("");
            setAddNewAccountCardDocument(true);
        }
        else {
            setAccountCodeName(selectedOption.value);
            setCompanyId(selectedOption.accountCaseId);
            const accountCard = accountCardOptions.find(option => option.name === selectedOption.value);
            setAccountCodeId(accountCard.cardId);
            type === 'Incomes' ? setDebitAccountOption(accountCard.cardId) : setCreditAccountOption(accountCard.cardId)
        }
    };

    const handleInvoiceAccount = (selectedOption) => {
        if (selectedOption.value1 === 'AddItem') {
            setAddNewAccountCard(true);
        } else {
            setInvoiceClientName(selectedOption.value);
            const accountCard = accountCardOptions.find(option => option.name === selectedOption.value);
            setInvoiceAccountCodeId(accountCard.cardId);
        }
    };

    const handleInvoiceItem = (index, selectedOption) => {
        if (selectedOption.value === 'add-item') {
            const updatedFlags = [...addItemFlags];
            updatedFlags[index] = true;
            setAddItemFlags(updatedFlags);
        } else {
            const accountCard = clientItems.find(option => option.makat === selectedOption.value);
            handleItemChange(index, 'makat', accountCard.makat);
            handleItemChange(index, 'name', accountCard.name);
            // Reset flag in case it was set
            const updatedFlags = [...addItemFlags];
            updatedFlags[index] = false;
            setAddItemFlags(updatedFlags);
        }
    };


    const handleUpdate = async (editedItem) => {

        setLocalLoading(true);
        try {
            // Use editedItem.docType if it exists and differs from type (e.g., cross-type duplication)
            // Otherwise fall back to type
            const documentType = editedItem.docType && editedItem.docType !== type ? editedItem.docType : type;
            const response = await DocumentService.UpdateDocument(documentType, token, editedItem);
            if (canProcessStatus) {
                if (editedItem.status == 'done') {
                    await handleDoneClick(editedItem.id);


                    // handleSortChange('id', 'newest', 'descending');
                }
                else if (editedItem.status == 'notDone') {
                    await handleNotDoneClick(editedItem.id)
                }
            }


            if (editedAddAccountCard) {

                await handleAccountCardSave(editedItem.accountCodeId, editedItem.accountCodeName, editedItem.accountCaseId);
                await fetchEnums(user, token, client);

            }

            if (response.ok) {
                setLocalLoading(false);

                if (isRange) {
                    await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate))
                }
                else
                    await fetchDocuments(new Date(sortDate));
                // Show success toast
                toast.success(t("documentUpdateSuccess"), { position: direction === 'rtl' ? 'top-left' : 'top-right' });
                // Removed handleCancel() so modal stays open after save
            } else {

                const errorText = await response.text();
                // Handle error

                // Show error toast
                console.error(errorText);

                toast.error(t("documentUpdateError"));
            }
        } catch (error) {
            // Handle error
            setLocalLoading(false);

            // Show error toast
            setEditingRow(null);
            setEditedItem({});
            toast.error(t("documentUpdateError"));
        }
        // setEditingRow(null);
        // setEditedItem({});
        setLocalLoading(false);

        setEditedAddAccountCard(false);
        // Refresh or update your data list
    };


    const handleCancel = () => {
        setEditedPopupItem(false);
        setEditingRow(null);
        setEditedItem({});
        setEditedAddAccountCard(false);
    };

    // Handle bulk update of JournalEntryType
    const handleBulkUpdateJournalEntryType = async (journalEntryType) => {
        if (selectedRows.length === 0) {
            toast.error(t('PleaseSelectAtLeastOneEntry') || 'Please select at least one entry');
            return;
        }

        setLocalLoading(true);
        try {
            const patch = { journalEntryType };
            const response = await DocumentService.BulkUpdateDocuments(
                type,
                selectedRows,
                patch,
                client.caseId,
                token
            );

            if (response.ok) {
                toast.success(t('JournalEntryTypeUpdatedSuccessfully') || 'Journal Entry Type updated successfully');
                setIsEditJournalEntryTypeModalOpen(false);

                // Refresh data (keep selection so button remains enabled)
                if (isRange) {
                    await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate));
                } else {
                    await fetchDocuments(new Date(sortDate));
                }
            } else {
                const errorText = await response.text();
                console.error(errorText);
                toast.error(t('documentUpdateError') || 'Error updating journal entry type');
            }
        } catch (error) {
            console.error('Error updating journal entry type:', error);
            toast.error(t('documentUpdateError') || 'Error updating journal entry type');
        } finally {
            setLocalLoading(false);
        }
    };


    const handleDocumentUpload = (event) => {
        setDocuments(Array.from(event.target.files));
    };

    const formatDate = dateString => {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const formatDateNew = dateString => {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    const formatMonthYearDate = dateString => {
        const date = new Date(dateString);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${month}/${year}`;
    };

    const closeCreateModal = (e) => {
        // Check if the clicked element is the same as the event handler's element
        if (modalCreateDocumentRef.current && !modalCreateDocumentRef.current.contains(e.target)) {
            handleClose();
        }
    }

    const closeCreateInvoiceModal = (e) => {
        // Check if the clicked element is the same as the event handler's element
        if (modalInvoiceCreateDocumentRef.current && !modalInvoiceCreateDocumentRef.current.contains(e.target)) {
            handleInvoiceClose();
        }
    }
    const closeSignatureInvoiceModal = (e) => {
        // Check if the clicked element is the same as the event handler's element
        if (signatureReferenceInvoiceModalVisibleRef.current && !signatureReferenceInvoiceModalVisibleRef.current.contains(e.target)) {
            handleSignatureReferenceClose();
        }
    }
    const handleClose = async () => {
        setModalVisible(false);
        setErrorMessage('');
        setOkMessage('');
        setDocumentCost("");
        setDocumentReference("")
        setCodeId("")
        setAccountCodeName("")
        setCreditAccountOption("")
        setDebitAccountOption("")
        setDescription("")
    }

    const handleInvoiceClose = async () => {
        setInvoiceDescription('');
        setInvoiceClientName('');
        setInvoiceClientCaseId('');
        setInvoiceClientLocation('');
        setInvoiceClientEmail('');
        setInvoiceAccountCodeId('');
        setInvoiceItems([]);
        setInvoiceDate(new Date());
        setInvoiceSignature('');
        setInvoiceReference('');
        setInvoiceClientPhoneNumber('');
        setAddNewAccountCard('');
        setPriceIncludingVAT(false);
        setInvoiceModalVisible(false);
        setChooseInvoiceModal(false);
    }

    const handleSignatureReferenceClose = async () => {
        setInvoiceSignature('');
        setInvoiceReference('');
        setSignatureReferenceInvoiceModalVisible(false);
    }

    const handleSignatureReferenceSave = async () => {
        setSignatureReferenceInvoiceModalVisible(false)
        setAddNewSignatureReference(true);
        setInvoiceModalVisible(true);
        setChooseInvoiceModal(true);
    }
    // const allFieldsFilled = sortCodeId && documentReference && documentCost && documentDate && creditAccountOption && debitAccountOption && accountCodeName && accountCodeId && description && photo
    const allFieldsFilled = (!autoFilling && documentCost) || (autoFilling && documents.length > 0);
    const signatureReferenceFilled = invoiceSignature && invoiceReference;
    const allClientItemFieldsFilled = invoiceClientName && invoiceClientCaseId && invoiceItems && invoiceItems.length > 0 && invoiceItems.every(item => {
        const hasRequiredFields = item.name && item.makat && item.price && item.discount >= 0; // Check if name, makat, and price are provided
        item.quantity = item.quantity || 1; // Default quantity to 1 if not provided
        item.discount = item.discount || 0; // Default discount to 1 if not provided
        return hasRequiredFields;
    });

    const handleSave = async () => {
        handleNormalSave();
    };

    const handleCancelAddJournalEntries = () => {
        setAddNewJournalEntry(false);
        setAddItem({
            accountCodeName: '',       // Account code name
            accountCaseId: '',         // Account case ID
            accountCodeId: '',         // Account case ID
            reference: '',             // Reference field
            description: '',           // Description of the entry
            uploadDate: new Date(),            // Upload date (formatted)
            documentDate: new Date(),          // Document date (formatted)
            amount: 0,                 // Amount (numeric)
            vat: 0,                    // VAT percentage
            creditAccount: '',         // Credit account
            debitAccount: '',          // Debit account
            sortCodeId: '',            // Sort code ID
            processed: false,          // Processed/unprocessed status
        });
    };
    const handleNormalSave = async (addItem) => {
        if (client?.isActive === false) {
            toast.error(t('ClientInactiveCannotCreateDocuments'));
            return;
        }
        // Validate the amount field or other required fields
        if (addItem.income === null) {
            setErrorMessage(t('errorFieldsNotFilled'));
            return;
        }

        setLocalLoading(true);

        // Prepare JSON payload

        let payload;

        const hasFiles = Array.isArray(addItem.documents) && addItem.documents.length > 0;

        if (hasFiles) {


            // multipart/form-data branch
            const fd = new FormData();
            fd.append('caseId', client.caseId);
            fd.append('accountantId', client.accountantId);
            fd.append('sortCodeId', addItem.sortCodeId ?? '');
            fd.append('reference', addItem.reference ?? '');
            fd.append('reference2', addItem.reference2 ?? '');
            fd.append('description', addItem.description ?? '');
            fd.append('amount', addItem.amount);
            fd.append('documentDate', new Date(addItem.documentDate).toISOString());
            fd.append('reportingMonthDate', addItem.reportingMonthDate ? new Date(addItem.reportingMonthDate).toISOString() : new Date(sortDate).toISOString());
            fd.append('registrationMonthDate', addItem.registrationMonthDate ? new Date(addItem.registrationMonthDate).toISOString() : new Date(sortDate).toISOString());
            fd.append('creditAccount', addItem.creditAccount ?? '');
            fd.append('debitAccount', addItem.debitAccount ?? '');
            fd.append('vat', addItem.vat);
            fd.append('confirmationNumber', addItem.confirmationNumber ?? '');
            fd.append('accountCaseId', addItem.accountCaseId ?? '');
            fd.append('uploadDate', new Date(addItem.uploadDate).toISOString());
            if (addItem?.foreignCurrencyAmount != null) {
                fd.append('foreignCurrencyAmount', addItem.foreignCurrencyAmount);
            }
            if (addItem?.foreignCurrencyCode != null) {
                fd.append('foreignCurrencyCode', addItem.foreignCurrencyCode);
            }
            // Add journalEntryType (default to 0 if not provided)
            fd.append('journalEntryType', addItem.journalEntryType ?? 0);
            fd.append('AddAsProcessed', (addItem.addAsProcessed === true).toString());

            addItem.documents.forEach(f => fd.append('Documents', f));  // files go here
            payload = fd;
        } else {
            // pure-JSON branch (exact shape you had)
            payload = {
                caseId: client.caseId,
                accountantId: client.accountantId,
                sortCodeId: addItem.sortCodeId,
                reference: addItem.reference,
                description: addItem.description,
                amount: addItem.amount,
                documentDate: new Date(addItem.documentDate).toISOString(),
                reportingMonthDate: addItem.reportingMonthDate ? new Date(addItem.reportingMonthDate).toISOString() : new Date(sortDate).toISOString(),
                registrationMonthDate: addItem.registrationMonthDate ? new Date(addItem.registrationMonthDate).toISOString() : new Date(sortDate).toISOString(),
                creditAccount: addItem.creditAccount,
                debitAccount: addItem.debitAccount,
                reference2: addItem.reference2,
                vat: addItem.vat,
                confirmationNumber: addItem.confirmationNumber,
                accountCaseId: addItem.accountCaseId,
                uploadDate: addItem.uploadDate,
                foreignCurrencyAmount: addItem?.foreignCurrencyAmount ?? null,
                foreignCurrencyCode: addItem?.foreignCurrencyCode ?? null,
                journalEntryType: addItem.journalEntryType ?? 0,  // Default to NormalJournal (0) if not provided
                addAsProcessed: addItem.addAsProcessed === true,
            };
        }

        try {
            let response = '';
            if (hasFiles) {
                response = await DocumentService.UploadDocumentJournalEntryWithDocument(type, payload, token);
            } else {
                response = await DocumentService.UploadDocumentPayload(type, payload, token);

            }

            if (response.ok) {
                const segId =
                    addItem.segmentationId ??
                    addItem.SegmentationId ??
                    addItem.projects?.[0]?.projectId;
                if (segId) {
                    try {
                        const created = await response.json();
                        const journalEntryId =
                            created?.journalEntryId ?? created?.JournalEntryId;
                        if (journalEntryId) {
                            const assignRes = await ProjectsService.assignDocuments(
                                {
                                    SegmentationId: String(segId),
                                    CaseId: client.caseId,
                                    JournalEntryIds: [journalEntryId],
                                },
                                token
                            );
                            if (!assignRes.ok) {
                                const errText = await assignRes.text();
                                toast.error(errText || t('ErrorUpdatingProject'));
                            }
                        }
                    } catch (assignErr) {
                        console.error(assignErr);
                        toast.error(t('ErrorUpdatingProject'));
                    }
                }
                if (addNewAccountCardDocument) {
                    await handleAccountCardSave(accountCodeId, accountCodeName);
                    await fetchEnums(user, token, client);
                }
                toast.success(t('documentUploadSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentUploadError', { errorText }));
            }
        } catch (error) {
            toast.error(t('documentUploadError', { errorText: 'Error uploading document' }));
        }

        setAddNewJournalEntry(false);
        setAddItem({
            accountCodeName: '',       // Account code name
            accountCaseId: '',         // Account case ID
            reference: '',             // Reference field
            description: '',           // Description of the entry
            uploadDate: new Date().toISOString(),            // Upload date (formatted)
            documentDate: new Date(),          // Document date (formatted)
            amount: '',                 // Amount (numeric)
            vat: 0,                    // VAT percentage
            creditAccount: '',         // Credit account
            debitAccount: '',          // Debit account
            sortCodeId: '',            // Sort code ID
            processed: false,          // Processed/unprocessed status
        });

        // Reset the modal form data for new entries
        if (isAddMode) {
            const resetFormData = {
                accountCodeName: '',       // Account code name
                accountCaseId: '',         // Account case ID
                accountCodeId: '',         // Account case ID
                reference: '',             // Reference field
                description: '',           // Description of the entry
                uploadDate: new Date(),            // Upload date (formatted)
                documentDate: new Date(),          // Document date (formatted)
                amount: '',                 // Amount (numeric)
                vat: 0,                    // VAT percentage
                creditAccount: '',         // Credit account
                debitAccount: '',          // Debit account
                sortCodeId: '3',            // Sort code ID
                processed: false,          // Processed/unprocessed status
                registrationMonthDate: new Date(sortDate).toISOString(), // Set from sortDate
                reportingMonthDate: new Date(sortDate).toISOString(),    // Set from sortDate
                foreignCurrencyCode: null,
                foreignCurrencyAmount: null,
                documents: []
            };
            setCurrentRowData(resetFormData);
        }

        await fetchDocuments(new Date(sortDate));
        await fetchDocumentsNotification(client, token);
        handleSortChange('uploadDate', 'date');
        setLocalLoading(false);
    };




    const handleOCRSave = async () => {
        if (!allFieldsFilled) {
            setErrorMessage(t('errorFieldsNotFilled'));
            return; // Stop execution if fields are not filled
        }
        setLocalLoading(true);

        const formData = new FormData();
        formData.append('CaseId', client.caseId);
        formData.append('AccountantId', user.accountantId);
        formData.append('ReportingMonthDate', new Date(sortDate).toISOString());
        formData.append('DocumentFileType', type);
        formData.append('VAT', documentVat)
        documents.forEach(document => {
            formData.append("documents", document, document.name);
        });


        try {
            const response = await DocumentService.UploadOCRDocument(type, formData, token);
            if (response.ok) {
                toast.success(t('documentUploadSuccess'));
            } else {
                const errorText = await response.text();
                toast.error(t('documentUploadError', { errorText }));
            }
        } catch (error) {
            toast.error(t('documentUploadError', { errorText: 'Error uploading document' }));
        }
        setModalVisible(false);
        setDocuments([])
        await fetchDocuments(new Date(sortDate));
        await fetchDocumentsNotification(client, token)
        await fetchEnums(user, token, client);
        handleSortChange('uploadDate', 'date');
        setLocalLoading(false);
    };

    const updateLocationState = async (newClientData) => {

        const updatedClientData = {
            ...location.state.client,
            ...newClientData
        };

        // Navigate with the updated client data and replace the current state
        setIsFirstUserFetched(false);
        navigate(location.pathname, {
            replace: true,
            state: { client: updatedClientData, type, sortDate }
        });
    };


    const handleAccountCardSave = async (AccountCodeId, AccountCodeName, CompanyId) => {

        let response2;
        if (type === 'Incomes') {

            response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, CompanyId, "לקוחות", token);

        } else {

            response2 = await EnumsService.AddAccountCard(client.caseId, AccountCodeId, AccountCodeName, CompanyId, "ספקים", token);
        }
        if (!response2.ok) {

            throw new Error(`HTTP error! status: ${response2.status}`);
        }
    };

    const saveNewItemsToDatabase = async () => {
        // Filter out undefined items
        const filteredItems = newItems.filter(item => item !== undefined);

        // Assuming EnumsService.AddClientItems expects an array of items
        const response = await EnumsService.AddClientItems(filteredItems, token);

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        // Reset newItems after saving
        setNewItems([]);
        // Optionally reset addItemFlags if necessary
        setAddItemFlags([]);

        return response;
    };
    const InvoiceModalTypes = [
        { controller: "Incomes", endPoint: "GenerateIncomePdf", type: "", TransactionDocumentType: "", TransactionDocumentTitle: "", title: "generateInvoice" },
        { controller: "Incomes", endPoint: "GenerateRefundIncomePdf", type: "", TransactionDocumentType: "", TransactionDocumentTitle: "", title: "generateCreditNote" },
    ]

    const [subAccountants, setSubAccountants] = useState([]);
    const [subAccountantOptions, setSubAccountantOptions] = useState([]);
    const [accountant, setAccountant] = useState({});

    const [assets, setAssets] = useState([]);
    const [showAddGroupModal, setShowAddGroupModal] = useState(false);
    const [assetGroups, setAssetGroups] = useState([]);

    const handleOpenGroudAdd = () => {
        setShowAddGroupModal(true);
    }

    const fetchEnums = async (user, token, client, options = {}) => {
        if (!client?.caseId || !token) return;
        if (enumsFetchInFlightRef.current && !options.forceRefetch) return;
        enumsFetchInFlightRef.current = true;
        try {
            await dispatch(
                fetchDocumentEnums({
                    caseId: client.caseId,
                    accountantId: client.accountantId,
                    token,
                    addItemLabel: t('AddItem'),
                    addAccountCardLabel: t('AddAccountCard'),
                    clientName: client.name,
                    forceRefetch: options.forceRefetch === true,
                })
            ).unwrap();
        } catch (error) {
            console.error('Error fetching enum data:', error);
            toast.error(t('enumFetchError', { errorText: error?.message }));
        } finally {
            enumsFetchInFlightRef.current = false;
        }
    };



    const fetchDocumentsNotification = async (client, token) => {
        const documentCounts = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);

        const enrichedClient = {
            ...client,
            totalCounts: documentCounts?.totalCounts ?? 0,
            documentCounts: documentCounts?.documentCounts ?? {},
            documentIds: documentCounts?.documentIds ?? {},
        };
        setInvoiceSignature(enrichedClient.signature);
        setClient(enrichedClient);
        return enrichedClient;
    }
    useEffect(() => {
        const fetchUserData = async () => {
            if (fetchUserDataInFlightRef.current) return;
            fetchUserDataInFlightRef.current = true;
            try {
                const currentUser = await UserService.getCurrentUser();
                const currentToken = await UserService.getCurrentToken();
                if (currentUser && currentToken) {
                    setUser(currentUser);
                    setToken(currentToken);

                    if (location.state && location.state.client && location.state.type) {
                        setType(location.state.type);
                        const enriched = await fetchDocumentsNotification(location.state.client, currentToken);
                        const fullClient = await ClientService.GetClient(currentToken, location.state.client.caseId);
                        const merged = { ...enriched, isActive: fullClient?.isActive !== undefined ? fullClient.isActive : enriched.isActive };
                        setClient(merged);
                        if (merged?.caseId && !enumsFetchInFlightRef.current) {
                            enumsFetchInFlightRef.current = true;
                            try {
                                await dispatch(
                                    fetchDocumentEnums({
                                        caseId: merged.caseId,
                                        accountantId: merged.accountantId,
                                        token: currentToken,
                                        addItemLabel: t('AddItem'),
                                        addAccountCardLabel: t('AddAccountCard'),
                                        clientName: merged.name,
                                    })
                                ).unwrap();
                            } finally {
                                enumsFetchInFlightRef.current = false;
                            }
                        }
                    }

                    if (location.state?.start && location.state?.end) {
                        setSortDate(location.state.start);
                        setIsRange(false);
                    }
                } else {
                    navigate("/login");
                }
            } catch (error) {
                // Handle error
            } finally {
                fetchUserDataInFlightRef.current = false;
            }
        };

        fetchUserData();
    }, [location.state?.client]);

    useEffect(() => {
        Object.keys(documentUpdate).forEach(updateCaseId => {
            const update = documentUpdate[updateCaseId];
            if (client?.caseId === updateCaseId) {
                setClient(prev => prev ? {
                    ...prev,
                    totalCounts: update.totalCounts,
                    documentIds: update.documentsIds,
                    documentsCount: update.documentsCount
                } : prev);
            }
        });
    }, [documentUpdate]);

    // Lazy-load full documentIds so the processed column filter can distinguish processed vs unprocessed
    useEffect(() => {
        if (!client?.caseId || !token) return;
        if (client.documentIds?.journalEntries !== undefined) return;

        let cancelled = false;
        (async () => {
            const full = await ClientDocumentCountService.getClientDocumentCountByCaseId(client.caseId, token);
            if (cancelled || !full) return;
            setClient(prev => prev ? { ...prev, documentIds: full.documentIds || {} } : prev);
        })();
        return () => { cancelled = true; };
    }, [client?.caseId, client?.documentIds?.journalEntries, token]);




    const extractVatByType = (data) => {
        setDenseTableCreditDebitHeader([
            t("Difference"),
            t("TotalCreditAccount"),
            t("TotalDebitAccount")
        ]);

        let creditSum = 0;
        let debitSum = 0;

        data.forEach(item => {
            if (item.creditAccount) {
                creditSum += parseFloat(item.amount) || 0;
            }
            if (item.debitAccount) {
                debitSum += parseFloat(item.amount) || 0;
            }
        });

        // ✅ Round to 2 decimal places to avoid floating point errors
        creditSum = Math.round(creditSum * 100) / 100;
        debitSum = Math.round(debitSum * 100) / 100;
        const diff = Math.round((debitSum - creditSum) * 100) / 100;

        // Update the source of truth if needed
        const updatedTotals = {
            creditAmount: creditSum,
            debitAmount: debitSum,
        };
        setDenseTableCreditDebit(updatedTotals);

        setDenseTableCreditDebitRows([
            {
                Difference: beautifyNumber(diff),
                TotalCreditAccount: beautifyNumber(creditSum),
                TotalDebitAccount: beautifyNumber(debitSum)
            }
        ]);
    };


    useEffect(() => {
        let diff = denseTableCreditDebit.debitAmount - denseTableCreditDebit.creditAmount;
        setDenseTableCreditDebitRows([{ Difference: beautifyNumber(diff), TotalCreditAccount: beautifyNumber(denseTableCreditDebit.creditAmount), TotalDebitAccount: beautifyNumber(denseTableCreditDebit.debitAmount) }]);
    }, [denseTableCreditDebit]);

    // Dense table header/rows from API when available
    useEffect(() => {
        if (denseTableCreditDebitHeaderFromRedux?.length) setDenseTableCreditDebitHeader(denseTableCreditDebitHeaderFromRedux.map(h => t(h)));
        else if (creditDebitSumFromRedux) setDenseTableCreditDebitHeader([t('Difference'), t('TotalCreditAccount'), t('TotalDebitAccount')]);
    }, [denseTableCreditDebitHeaderFromRedux, creditDebitSumFromRedux, t]);
    useEffect(() => {
        if (denseTableCreditDebitRowsFromRedux?.length) setDenseTableCreditDebitRows(denseTableCreditDebitRowsFromRedux);
    }, [denseTableCreditDebitRowsFromRedux]);

    // Sync Redux document enums to local state (same as Document.jsx)
    useEffect(() => {
        if (!documentEnumsFromRedux || !client?.caseId) return;
        const e = documentEnumsFromRedux;
        const get = (camel, pascal) => e[camel] ?? e[pascal] ?? [];
        const getObj = (camel, pascal) => e[camel] ?? e[pascal];
        setSortCodeIdOptions(get('sortCodeIdOptions', 'SortCodeIdOptions') || []);
        setAccountCardOptions(get('accountCardOptions', 'AccountCardOptions') || []);
        setCreditAccountOptions(get('creditAccountOptions', 'CreditAccountOptions') || []);
        setDebitAccountOptions(get('debitAccountOptions', 'DebitAccountOptions') || []);
        setAccountCardEditDownloadOptions(get('accountCardEditDownloadOptions', 'AccountCardEditDownloadOptions') || []);
        setClientItems(get('clientItems', 'ClientItems') || []);
        setFormattedPalCodeOptions(get('formattedPalCodeOptions', 'FormattedPalCodeOptions') || []);
        setAssets(get('assets', 'Assets') || []);
        setAssetGroups(get('assetGroups', 'AssetGroups') || []);
        setSubAccountants(get('subAccountants', 'SubAccountants') || []);
        setSubAccountantOptions(get('subAccountantOptions', 'SubAccountantOptions') || []);
        const acc = getObj('accountant', 'Accountant');
        if (acc) setAccountant(acc);
        setIsFirstUserFetched(true);
    }, [documentEnumsFromRedux, client?.caseId]);



    const fetchDocuments = async (selectedDate) => {
        await fetchPageData(new Date(selectedDate), new Date(selectedDate), false);
    };




    const handleSetInvoiceDate = async (date) => {
        const response1 = await ClientService.CheckIfMonthClosed(client.caseId, date, token);
        const isClosedReportingMonth = await response1.json();
        if (isClosedReportingMonth) {
            toast.info(t('MonthReportAlreadyClosedTryAgain'));
            return
        }
        setInvoiceDate(date)
    }



    useEffect(() => {
        if (!client?.caseId || !token) return;

        const modeChanged =
            prevIsRangeRef.current !== null &&
            (prevIsRangeRef.current !== isRange || prevUseRegistrationMonthRef.current !== useRegistrationMonth);
        prevIsRangeRef.current = isRange;
        prevUseRegistrationMonthRef.current = useRegistrationMonth;
        const shouldFetch = isFirstUserFetched || modeChanged;
        if (!shouldFetch) return;

        const hasExistingData = (rawDocumentsFromRedux?.length ?? 0) > 0;
        const backgroundRefresh = hasExistingData && !modeChanged;

        if (modeChanged) dispatch(setJournalEntryPageDocuments([]));
        if (!isRange) fetchPageData(new Date(sortDate), new Date(sortDate), false, { backgroundRefresh });
        else fetchPageData(new Date(startDate), new Date(endDate), true, { backgroundRefresh });
    }, [isFirstUserFetched, useRegistrationMonth, client?.caseId, token, isRange, sortDate, startDate, endDate]);

    const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
        <button className={`document-custom-input ${isRange ? "document-custom-input-range" : ""}`} onClick={onClick} ref={ref}>
            {value}
        </button>
    ));


    const CustomInput1 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="document-custom-input1" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));

    const CustomInput2 = React.forwardRef(({ value, onClick }, ref) => (
        <button className="edit-custom-input" onClick={onClick} ref={ref}>
            {value}
        </button>
    ));



    const CustomDownloadInput = React.forwardRef(({ value, placeholderText, onClick }, ref) => {
        return (
            <button className="download-document-custom-input" onClick={onClick} ref={ref}>
                {value || placeholderText}
            </button>
        );
    });

    const [openedIframeUrl, setOpenedIframeUrl] = useState('');
    const [bigIframeModalOpen, setBigIframeModalOpen] = useState(false);
    const openPdfInNewTab = (pdfUrl) => {
        // window.open(pdfUrl, '_blank');
        setOpenedIframeUrl(pdfUrl ? pdfUrl : NoDocumentsPdf);
        setBigIframeModalOpen(true);
    };
    const handleCloseIframeModal = () => {
        setBigIframeModalOpen(false);
        setOpenedIframeUrl('');
    };

    const [openJournalDocModal, setOpenJournalDocModal] = useState(false);
    const handleDownloadJournalEntryDocumentation = async () => setOpenJournalDocModal(true);
    // The modal payload carries the report options plus every filter field; the reports
    // service decides which of them end up in the request body.
    const onSubmitJournalDocumentation = async (options) => {
        const {
            types,
            sortBy,
            sortDirection,
            format,
            startDate: modalStart,
            endDate: modalEnd,
            includeDescription = true,
            documentIds = null,
        } = options;
        setLocalLoading(true);
        try {
            const StartDate = modalStart ? modalStart : (isRange ? startDate : sortDate);
            const EndDate = modalEnd ? modalEnd : (isRange ? endDate : sortDate);
            const selectedTypes = (types && types.length > 0) ? types : [type?.toLowerCase()];
            // The modal decides the scope: a row selection or a filtered report over the whole period.
            const finalDocumentIds = documentIds;
            const filters = options;

            if (format === 'excel') {
                const blob = await ReportsService.getJournalEntryDocumentationExcel(
                    client.caseId,
                    StartDate,
                    EndDate,
                    selectedTypes,
                    token,
                    sortBy,
                    sortDirection,
                    includeDescription,
                    finalDocumentIds,
                    filters
                );
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `JournalDocumentation-${client.caseId}.xlsx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            } else {
                // PDF
                const blob = (selectedTypes.length > 1)
                    ? await ReportsService.getJournalEntryDocumentationCombinedPdf(
                        client.caseId,
                        StartDate,
                        EndDate,
                        selectedTypes,
                        token,
                        sortBy,
                        sortDirection,
                        includeDescription,
                        finalDocumentIds,
                        filters
                    )
                    : await ReportsService.getJournalEntryDocumentation(
                        client.caseId,
                        StartDate,
                        EndDate,
                        selectedTypes[0],
                        token,
                        sortBy,
                        sortDirection,
                        includeDescription,
                        finalDocumentIds,
                        filters
                    );

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `JournalDocumentation-${client.caseId}.pdf`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (error) {
            console.error('Error downloading journal documentation:', error);
            toast.error(t('documentDownloadError', { errorText: error.message }));
        }
        setOpenJournalDocModal(false);
        setLocalLoading(false);
    };
    const handleSortCodeChange = (selectedOption) => {
        // Set the sortCodeId to the value from the selected option
        setCodeId(selectedOption.value);

        // Extract the name without the parentheses
        const nameWithoutParentheses = selectedOption.name.replace(/\s*\(.*?\)\s*/, '').trim();

        // Check for a number within parentheses
        const match = selectedOption.name.match(/\((\d+)%?/);
        let customVat = match ? parseInt(match[1], 10) : null;

        const sortCode = sortCodeIdOptions.filter(sc => sc.sortCodeId === selectedOption.value)[0];

        // Determine the VAT based on the name without parentheses
        if (Constants.SortCodesWith66Vat.includes(nameWithoutParentheses)) {
            setDocumentVat(66);
        } else if (Constants.SortCodesWithZeroVat.includes(nameWithoutParentheses) || sortCode.sortCodeVatType === 0) {
            setDocumentVat(0);
        } else if (Constants.SortCodesWith16Vat.includes(nameWithoutParentheses)) {
            setDocumentVat(16);
        }
        else if (customVat !== null) {
            // If a custom VAT was found, use it
            setDocumentVat(customVat === Constants.Vat66 ? Constants.Vat66 : customVat);
        } else {
            // Default VAT if no special conditions are met
            setDocumentVat(100);
        }
    };


    const handleSortChange = (key, type, Direction = '') => {
        let direction = Direction || 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction, type });
    };

    // Journal Entry Type options
    const journalEntryTypeOptions = JOURNAL_ENTRY_TYPE_OPTIONS;

    const loadSegmentationProjects = useCallback(async () => {
        if (!client?.caseId || !token) return;
        setLoadingSegmentations(true);
        try {
            const res = await ProjectsService.getProjects(client.caseId, token);
            if (!res.ok) {
                toast.error(t('ErrorRetrievingProjects'));
                return;
            }
            const raw = await res.json();
            const list = Array.isArray(raw) ? raw : [];
            const mapped = list
                .map((p) => ({
                    id: String(p.projectId ?? p.id ?? ''),
                    code: p.code ?? '',
                    name: p.name ?? '',
                    label: `${p.code ?? ''} — ${p.name ?? ''}`,
                }))
                .filter((p) => p.id)
                .sort((a, b) => compareProjectCodes(a, b));
            setSegmentationProjects(mapped);
        } catch (e) {
            console.error(e);
            toast.error(t('ErrorRetrievingProjects'));
        } finally {
            setLoadingSegmentations(false);
        }
    }, [client?.caseId, token, t, compareProjectCodes]);

    const handleByProjectsFilterToggle = async (active) => {
        if (!active) {
            setByProjectsFilterActive(false);
            setSelectedFromSegmentation(null);
            setSelectedToSegmentation(null);
            return;
        }
        setByProjectsFilterActive(true);
        setSelectedFromSegmentation(null);
        setSelectedToSegmentation(null);
        await loadSegmentationProjects();
    };

    const handleFromSegmentationChange = (_, newVal) => {
        if (!byProjectsFilterActive) return;
        let from = newVal;
        let to = selectedToSegmentation;
        if (from && to && compareProjectCodes(from, to) > 0) {
            toast.info(t('ProjectRangeAdjustedToCodeOrder'));
            const tmp = from;
            from = to;
            to = tmp;
            setSelectedToSegmentation(to);
        }
        setSelectedFromSegmentation(from);
    };

    const handleToSegmentationChange = (_, newVal) => {
        if (!byProjectsFilterActive) return;
        let to = newVal;
        let from = selectedFromSegmentation;
        if (from && to && compareProjectCodes(from, to) > 0) {
            toast.info(t('ProjectRangeAdjustedToCodeOrder'));
            const tmp = to;
            to = from;
            from = tmp;
            setSelectedFromSegmentation(from);
        }
        setSelectedToSegmentation(to);
    };

    const allowedSegmentationIds = useMemo(() => {
        if (!byProjectsFilterActive) return null;
        if (!segmentationProjects.length) return null;
        const ordered = [...segmentationProjects].sort((a, b) => compareProjectCodes(a, b));
        if (!selectedFromSegmentation?.id && !selectedToSegmentation?.id) {
            return new Set(ordered.map((p) => String(p.id)));
        }
        const fromSeg = selectedFromSegmentation
            ? ordered.find((p) => String(p.id) === String(selectedFromSegmentation.id))
            : null;
        const toSeg = selectedToSegmentation
            ? ordered.find((p) => String(p.id) === String(selectedToSegmentation.id))
            : null;
        let fromCode = fromSeg?.code ?? null;
        let toCode = toSeg?.code ?? null;
        if (
            fromCode != null &&
            toCode != null &&
            compareProjectCodes({ code: fromCode }, { code: toCode }) > 0
        ) {
            [fromCode, toCode] = [toCode, fromCode];
        }
        const selected = ordered.filter((s) => {
            const geFrom =
                fromCode == null ||
                compareProjectCodes({ code: s.code }, { code: fromCode }) >= 0;
            const leTo =
                toCode == null ||
                compareProjectCodes({ code: s.code }, { code: toCode }) <= 0;
            return geFrom && leTo;
        });
        return new Set(selected.map((p) => String(p.id)));
    }, [
        byProjectsFilterActive,
        segmentationProjects,
        selectedFromSegmentation,
        selectedToSegmentation,
        compareProjectCodes,
    ]);

    const filteredAndSortedData = useMemo(() => {
        if (data.length < 0) {
            return;
        }
        let filteredData = data;
        if (showOnlyUnprocessed && client?.documentIds?.journalEntries) {
            const unprocessedIds = client.documentIds.journalEntries ?? [];
            filteredData = unprocessedIds.length ? filteredData.filter(item => unprocessedIds.includes(item.id)) : filteredData;
        }
        // Filter by JournalEntryType if any types are selected
        if (selectedJournalEntryTypes.length > 0) {
            const selectedValues = selectedJournalEntryTypes.map(s =>
                typeof s === 'object' && s.value !== undefined ? s.value : s
            );
            filteredData = filteredData.filter((item) => {
                // Try both camelCase and PascalCase field names
                const itemType = item.journalEntryType ?? item.JournalEntryType ?? 0; // Default to 0 if null/undefined
                return selectedValues.includes(itemType);
            });
        }

        if (allowedSegmentationIds) {
            filteredData = filteredData.filter((item) => {
                const segId = item.segmentationId ?? item.SegmentationId;
                return segId != null && segId !== '' && allowedSegmentationIds.has(String(segId));
            });
        }

        const sortedData = filteredData.filter((item) => {
            const query = searchQuery.toLowerCase().trim();
            if (!query) return true;
            const amountString = item?.amount?.toString();
            const sortCode = sortCodeIdOptions?.find((o) => o.sortCodeId === item?.sortCodeId);
            const sortCodeName = (item?.sortCodeName ?? sortCode?.sortCodeName)?.toLowerCase?.() || '';
            const sortCodeLabel = sortCode ? `${sortCode.sortCodeId} - ${sortCode.sortCodeName}`.toLowerCase() : '';
            const sortCodeLabelReversed = sortCode ? `${sortCode.sortCodeName} - ${sortCode.sortCodeId}`.toLowerCase() : '';
            const creditCard = accountCardOptions?.find((o) => String(o.cardId) === String(item?.creditAccount));
            const debitCard = accountCardOptions?.find((o) => String(o.cardId) === String(item?.debitAccount));
            const accountCard = accountCardOptions?.find((o) => String(o.cardId) === String(item?.accountCodeId));
            const accountCardName = (item?.accountCodeName ?? accountCard?.name)?.toLowerCase?.() || '';
            const creditLabel = creditCard ? `${creditCard.cardId} - ${creditCard.name}`.toLowerCase() : '';
            const debitLabel = debitCard ? `${debitCard.cardId} - ${debitCard.name}`.toLowerCase() : '';
            const accountLabel = accountCard ? `${accountCard.cardId} - ${accountCard.name}`.toLowerCase() : '';
            return (
                item?.accountCodeName?.toLowerCase()?.includes(query) ||
                item?.accountCodeId?.toString()?.includes(query) ||
                item?.creditAccount?.toString()?.includes(query) ||
                item?.debitAccount?.toString()?.includes(query) ||
                accountCardName?.includes(query) ||
                (creditCard?.name?.toLowerCase()?.includes(query)) ||
                (debitCard?.name?.toLowerCase()?.includes(query)) ||
                creditLabel?.includes(query) ||
                debitLabel?.includes(query) ||
                accountLabel?.includes(query) ||
                amountString?.includes(query) ||
                formatDate(item?.documentDate)?.includes(query) ||
                item?.reference?.toLowerCase?.()?.includes(query) ||
                item?.sortCodeId?.toString()?.includes(query) ||
                sortCodeName?.includes(query) ||
                sortCodeLabel?.includes(query) ||
                sortCodeLabelReversed?.includes(query) ||
                item?.description?.toLowerCase?.()?.includes(query) ||
                item?.uploadNumber?.toString()?.includes(query)
            );
        });
        if (sortConfig.key) {
            sortedData.sort((a, b) => {
                if (sortConfig.type === 'newest') {
                    const highlightedIds = type === 'JournalEntries'
                        ? (client.documentIds?.journalEntries ?? [])
                        : type === 'Incomes'
                            ? (client.documentIds?.incomes ?? [])
                            : (client.documentIds?.expenses ?? []);
                    const aIsHighlighted = highlightedIds.includes(a.id);
                    const bIsHighlighted = highlightedIds.includes(b.id);

                    if (sortConfig.direction === 'ascending') {
                        // Ascending: Non-highlighted (older) items first
                        if (!aIsHighlighted && bIsHighlighted) {
                            return -1; // 'a' should come before 'b' (a is older, hence "lower")
                        } else if (aIsHighlighted && !bIsHighlighted) {
                            return 1;  // 'b' should come before 'a' (b is older, hence "lower")
                        }
                    } else {
                        // Descending: Highlighted (newer) items first
                        if (aIsHighlighted && !bIsHighlighted) {
                            return -1; // 'a' should come before 'b' (a is newer, hence "higher")
                        } else if (!aIsHighlighted && bIsHighlighted) {
                            return 1;  // 'b' should come before 'a' (b is newer, hence "higher")
                        }
                    }
                } else {
                    const aValue = a[sortConfig.key] || ""; // Default to empty string if null or undefined
                    const bValue = b[sortConfig.key] || ""; // Default to empty string if null or undefined
                    if (sortConfig.type === 'number') {
                        return sortConfig.direction === 'ascending' ? aValue - bValue : bValue - aValue;
                    } else if (sortConfig.type === 'date') {
                        return sortConfig.direction === 'ascending' ? new Date(aValue) - new Date(bValue) : new Date(bValue) - new Date(aValue);
                    } else { // default to string comparison
                        return sortConfig.direction === 'ascending' ? aValue?.localeCompare(bValue) : bValue?.localeCompare(aValue);
                    }
                }
            });
        }

        return sortedData;
    }, [
        data,
        searchQuery,
        sortConfig,
        selectedJournalEntryTypes,
        showOnlyUnprocessed,
        client,
        sortCodeIdOptions,
        accountCardOptions,
        allowedSegmentationIds,
    ]);

    const handleGridFilteredRowsChange = useCallback((filteredRows) => {
        setGridFilteredData((prev) => {
            // Compare row references, not ids: a refetch keeps the same ids but brings new row
            // objects, and keeping `prev` would leave next/previous navigating stale values.
            const sameRows = prev != null && filteredRows != null &&
                prev.length === filteredRows.length &&
                prev.every((row, i) => row === filteredRows[i]);
            return sameRows ? prev : filteredRows;
        });
    }, []);

    // The currently visible rows (after page search + grid column filters).
    // Used for EditModal next/previous navigation so it respects the active filter.
    const denseTableSource = gridFilteredData ?? filteredAndSortedData;

    // Sync from Redux when not showing a filtered subset (must be after filteredAndSortedData is defined)
    useEffect(() => {
        const sourceData = (gridFilteredData ?? filteredAndSortedData ?? []).filter((r) => r.id !== 'NEW_ROW');
        const hasSubsetFilter =
            byProjectsFilterActive ||
            (data.length > 0 && sourceData.length < data.length);
        if (hasSubsetFilter) {
            extractVatByType(sourceData);
            return;
        }
        if (creditDebitSumFromRedux) {
            setDenseTableCreditDebit({ creditAmount: creditDebitSumFromRedux.creditSum ?? 0, debitAmount: creditDebitSumFromRedux.debitSum ?? 0 });
            setMissingAccountCards(missingCardsFromRedux || []);
        }
    }, [
        creditDebitSumFromRedux,
        missingCardsFromRedux,
        data.length,
        filteredAndSortedData,
        gridFilteredData,
        byProjectsFilterActive,
    ]);

    const handleGoBack = () => {
        // Navigate back to the previous page using React Router
        if (client) {
            // navigate(-1, {
            //     state: { ...location.state, client },
            // });
            goBack()
        }
    };

    const handleSelectRows = (ids) => {
        if (ids && ids.length === 0) {
            setSelectedRows([]);
            return
        }
        setSelectedRows(ids);

        // let newSelected = [...selectedRows]; // Start with the current selected IDs

        // ids.forEach((id) => {
        //     // Find the item in filteredAndSortedData that matches the selected id
        //     const item = filteredAndSortedData.find((row) => row.id === id);
        //     if (!item) return; // Skip if the item with the given id isn't found

        //     // Apply the same condition used for displaying checkboxes
        //     const condition = client.accountManagement === Constants.AccountManagementOptions[0].name
        //         ? item.sortCodeId && item.creditAccount && item.debitAccount
        //         : item.sortCodeId;

        //     if (!condition) return; // Skip if the item doesn't meet the condition

        //     // Check if the id is already in selectedRows
        //     const selectedIndex = newSelected.indexOf(id);

        //     // Add or remove the id based on its presence in selectedRows
        //     if (selectedIndex === -1) {
        //         // ID is not selected, so add it
        //         newSelected.push(id);
        //     } else {
        //         // ID is selected, so remove it
        //         newSelected.splice(selectedIndex, 1);
        //     }
        // });

        // setSelectedRows(newSelected);
    };

    const handleAccountChange = (selectedOption, field, CustomDropdownFlag = false) => {
        setCompanyId(selectedOption.accountCaseId);
        if (field === 'debitAccount' || field === 'creditAccount') {
            if (selectedOption.value < 0) {
                setOriginalAccountCardId(editedItem.cardId)
            }
            setEditedItem({
                ...editedItem,
                [field]: selectedOption.value  // Use bracket notation to dynamically set the field
            });
        } else if (field === 'accountCodeId') {
            if (selectedOption.value1 === 'AddItem') {
                setEditedAddAccountCard(true);
                setOldAccountName(editedItem.accountCodeName);
                setOldAccountCaseId(editedItem.accountCaseId);
                setOldAccountCardId(editedItem.accountCodeId);
                setEditedItem({ ...editedItem, accountCodeName: '', accountCodeId: '', accountCaseId: '' });
            }
            else {
                const accountCardEdit = accountCardEditDownloadOptions.find(option =>
                    option.cardId === (CustomDropdownFlag ? selectedOption.cardId : selectedOption.value)
                );
                const name = accountCardEdit?.name;
                const accountCaseId = accountCardEdit?.accountCaseId;
                const cardId = CustomDropdownFlag ? selectedOption.cardId : selectedOption.value;
                setEditedItem({ ...editedItem, accountCodeName: name, accountCodeId: cardId, accountCaseId: accountCaseId })
            }
        }
    };


    const handleSetSortDate = (date) => {
        const newDate = new Date(date.getFullYear(), date.getMonth(), 10);
        localStorage.setItem('Date', newDate);
        setSortDate(newDate);
        fetchDocuments(newDate);
    }

    const closeDownloadModal = () => {
        setShowDownloadModal(false);
    };

    const handleRangeChange = async () => {
        !isRange ? await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate)) : await fetchDocuments(new Date(sortDate));
        setIsRange(!isRange);
        localStorage.setItem('IsRange', !isRange);
    }

    const handleOpenInvoiceCreator = () => {
        setChooseInvoiceModal(true);
        // if (client.signature && client.invoicesNumbers) {
        //     setChooseInvoiceModal(true);
        //     //setInvoiceModalVisible(true);
        // }
        // else {
        //     setSignatureReferenceInvoiceModalVisible(true);
        // }
    };

    const handleOpenSpecificInvoiceCreator = (type) => {

        // setCurrentInvoiceCreatingType(type);
        setInvoiceTypeInModal(type);
        if (client.signature && client.invoicesNumbers) {
            setInvoiceTypeInModal(type);
            setChooseInvoiceModal(false);
            setInvoiceModalVisible(true);
        }
        else {
            setSignatureReferenceInvoiceModalVisible(true);
        }
    };

    const handleCloseAddNewAccountCardDocument = () => {
        setAccountCodeId("");
        setAccountCodeName("");
        setCompanyId("");
        setAddNewAccountCardDocument(false);
    };

    const handleCloseEditAddNewAccountCardDocument = () => {
        setEditedItem({ ...editedItem, accountCodeName: oldAccountName, accountCodeId: oldAccountCardId, accountCaseId: oldAccountCaseId });
        setEditedAddAccountCard(false);
    };

    const handleAccountCodeChange = (selectedOption) => {
        if (selectedOption?.value1 === 'AddItem') {
            // Clear formData fields when adding a new item
            setAddItem((prev) => ({
                ...prev,
                accountCodeId: cardIdOption,
                accountCaseId: '',
                accountCodeName: '',
            }));
            setAddNewAccountCardDocument(true);
        } else {
            // Set formData fields based on selected option
            const accountCard = accountCardOptions.find((option) => option.cardId === selectedOption?.value);

            setAddItem((prev) => ({
                ...prev,
                accountCodeId: selectedOption?.value || '',
                accountCaseId: selectedOption?.accountCaseId || '',
                accountCodeName: accountCard ? accountCard.name : '',
            }));
        }
    };

    const handleEditAddAccountChange = (selectedOption, field) => {
        if (field === 'AccountCodeId') {
            type === 'Incomes' ? setEditedItem({ ...editedItem, accountCodeId: selectedOption, debitAccount: selectedOption }) : setEditedItem({ ...editedItem, accountCodeId: selectedOption, creditAccount: selectedOption });
        }
        else if (field === 'AccountCodeName') {

            setEditedItem({ ...editedItem, accountCodeName: selectedOption })
        }
        else {
            setEditedItem({ ...editedItem, accountCaseId: selectedOption })

        }
    };

    const handlePriceIncludingVATChange = (event) => {
        setPriceIncludingVAT(event.target.value === 'true');
    };

    const handleRightClickAction = async (id, status, editedItem) => {

        if (!canProcessStatus) {
            return;
        }
        if (status === 'done') {
            if (client?.accountManagement?.trim() === Constants.AccountManagementOptions[0].name && (!editedItem.sortCodeId || !editedItem.creditAccount || !editedItem.debitAccount)) { /// means "כפולה"
                toast.info(t('DocumentMustHaveSortCodeCreditDebitAccountToMarkAsProcessed'));
                return
            }
            else if (!editedItem.sortCodeId) {
                toast.info(t('DocumentMustHaveSortCodeToMarkAsProcessed'));
                return
            }

        }
        if (status == 'done') {
            await handleDoneClick(id);
        }
        else if (status == 'notDone') {
            await handleNotDoneClick(id)
        }
        if (isRange) {
            await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate))
        }
        else
            await fetchDocuments(new Date(sortDate));
    };

    //table functions
    const headerStyle = {
        backgroundColor: '#f7f7f7',
        color: 'black',
        fontWeight: 'bold',
        zIndex: '10'
    }

    const tableContainerRef = useRef();
    const customScrollbarRef = useRef();



    const handleCustomScroll = (e) => {
        if (tableContainerRef.current) {
            tableContainerRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const handleTableScroll = (e) => {
        if (customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = e.target.scrollLeft;
        }
    };

    const synchronizeScroll = () => {
        if (tableContainerRef.current && customScrollbarRef.current) {
            customScrollbarRef.current.scrollLeft = tableContainerRef.current.scrollLeft;

        }
    };

    useEffect(() => {
        synchronizeScroll();
    }, [filteredAndSortedData]);

    useEffect(() => {
        if (tableContainerRef.current && customScrollbarRef.current) {
            customScrollbarRef.current.firstChild.style.width = `${tableContainerRef.current.scrollWidth}px`;
        }
    }, [filteredAndSortedData, tableContainerRef.current?.scrollWidth]);


    const RefreshPage = async () => {
        if (isRange)
            await fetchDataOnDateRangeChange(new Date(startDate), new Date(endDate))
        else
            await fetchDocuments(new Date(sortDate));

        await fetchDocumentsNotification(client, token);
        await fetchEnums(user, token, client, { forceRefetch: true });
    }

    const splitInfo = useMemo(
        () => splitSelectedRows(selectedRows, data),
        [selectedRows, data],
    );

    const handleDownloadMergedDocuments = async () => {
        if (selectedRows.length === 0) {
            toast.info(t('PleaseSelectOptionForSelectedRows'));
            return;
        }

        setLocalLoading(true);
        try {
            // Get the selected rows from filteredAndSortedData
            const rows = filteredAndSortedData.filter(row => selectedRows.includes(row.id));

            // Filter out rows without valid documentUrl (exclude NoDocumentsPdf)
            const validRows = rows.filter(row => row.documentUrl && row.documentUrl !== NoDocumentsPdf);

            if (validRows.length === 0) {
                toast.info(t('NoDocumentsFound'));
                setLocalLoading(false);
                return;
            }

            const urls = validRows.map(r => r.documentUrl);

            // Merge PDFs
            const merged = await PDFDocument.create();
            for (const url of urls) {
                try {
                    const bytes = await fetch(url).then(r => r.arrayBuffer());
                    const srcPdf = await PDFDocument.load(bytes);
                    const pages = await merged.copyPages(srcPdf, srcPdf.getPageIndices());
                    pages.forEach(p => merged.addPage(p));
                } catch (err) {
                    console.error(`Error loading PDF from ${url}:`, err);
                    // Continue with other PDFs even if one fails
                }
            }

            // Check if we have any pages in the merged document
            if (merged.getPageCount() === 0) {
                toast.error(t('NoDocumentsFound'));
                setLocalLoading(false);
                return;
            }

            // Create blob and download
            const mergedPdfBytes = await merged.save();
            const blob = new Blob([mergedPdfBytes], { type: 'application/pdf' });
            const blobUrl = URL.createObjectURL(blob);

            // Create download link
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = `merged_documents_${new Date().getTime()}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            // Clean up
            setTimeout(() => {
                URL.revokeObjectURL(blobUrl);
            }, 100);

            toast.success(t('DocumentsDownloaded'));
        } catch (err) {
            console.error('Error merging/downloading documents:', err);
            toast.error(t('MergeOrPrintFailed'));
        } finally {
            setLocalLoading(false);
        }
    };

    const [isEditingARow, setIsEditingARow] = useState(false);
    const Row = ({
        item,
        index,
    }) => {

        const [isEditing, setIsEditing] = useState(false);

        let isIdInChecks = (client.documentIds?.journalEntries ?? []).includes(item.id);
        const isItemSelected = isSelected(item.id);
        const undealtStyle = {
            boxShadow: isIdInChecks
                ? ''  // red with 50% opacity
                : 'inset 0px 2px 200px 0px rgba(57, 196, 94, 0.2)',  // #39c45e with 50% opacity
            borderRadius: '0px', // Adjust the radius as needed
        };
        const handleDoubleClick = () => {
            // setIsEditing(true); // Enable editing mode on double-click
            // setIsEditingARow(true);
            // handleEdit(item, index, false);
        };

        const handleCancel = () => {
            setIsEditing(false);
            setIsEditingARow(false);

        };

        // Render editable row when isEditing is true
        return isEditing ? (
            <TableRow key={item.id} sx={{ ...undealtStyle }} selected={isItemSelected}>
                {/* <TableCell align="left" onClick={() => openPdfInNewTab(item.documentUrl)}>
                    <div className="iframe-container">
                        <iframe
                            className="zoom-iframe"
                            src={item.documentUrl ? `${item.documentUrl}#page=1` : `${NoDocumentsPdf}#page=1`}
                            width="100px"
                            height="50px"
                            id={item.id}
                            title={item.title}
                            style={{ pointerEvents: 'none' }}
                        />
                    </div>
                </TableCell> */}
                <>
                    <TableCell align="right">
                        {!isIdInChecks ? (
                            <p style={{ color: 'green', fontSize: '16px', fontWeight: 'bold' }}>{t('processed')}</p>
                        ) : (
                            <p style={{ color: 'red', fontSize: '16px', fontWeight: 'bold' }}>{t('unprocessed')}</p>
                        )}
                    </TableCell>

                    {/* Select for Account Code Name */}
                    {/* <TableCell align="right">
                        <ReactSelect
                            options={accountCardOptions.map(option => ({
                                value: option.name,
                                label: option?.accountCaseId ? `${option.name} - ${option?.accountCaseId}` : option.name,
                                accountCaseId: option.accountCaseId || ''
                            }))}
                            value={accountCardOptions
                                .filter(option => option.name === editedItem.accountCodeName)
                                .map(option => ({
                                    value: option.name,
                                    label: option?.accountCaseId ? `${option.name} - ${option?.accountCaseId}` : option.name,
                                    accountCaseId: option.accountCaseId || ''
                                }))[0]}
                            onChange={(selectedOption) => handleAccountChange(selectedOption, 'accountCodeName')}
                            isDisabled={!isRange ? isClosedReportingMonthDisplay : editedItem.isClosedReportingMonth}
                            placeholder={t('SelectClientName')}
                        />
                    </TableCell> */}

                    {/* Account Case ID */}
                    <TableCell align="right">

                        <div className='td-container-2'>
                            <input
                                type="text"
                                className='edit-input-field-2'
                                value={editedItem.accountCaseId || ''}
                                onChange={(e) => handleChange(e, 'accountCaseId')}
                            // disabled={!isRange ? isClosedReportingMonth : editedItem.isClosedReportingMonth}
                            />
                        </div>
                    </TableCell>

                    {/* Reference */}
                    <TableCell align="right">
                        <div className='td-container-2'>
                            <input
                                type="text"
                                className='edit-input-field-2'
                                value={editedItem.reference || ''}
                                onChange={(e) => handleChange(e, 'reference')}
                            // disabled={!isRange ? isClosedReportingMonth : editedItem.isClosedReportingMonth}
                            />
                        </div>
                    </TableCell>

                    {/* Confirmation Number */}
                    <TableCell align="right">
                        <div className='td-container'>
                            <input
                                type="text"
                                className='edit-input-field-2'
                                value={editedItem.confirmationNumber || ''}
                                onChange={(e) => handleChange(e, 'confirmationNumber')}
                            // disabled={!isRange ? isClosedReportingMonth : editedItem.isClosedReportingMonth}
                            />
                        </div>
                    </TableCell>
                    {/* Description */}
                    <TableCell align="right">
                        <div className='td-container'>
                            <input
                                type="text"
                                className='edit-input-field-2'
                                value={editedItem.description || ''}
                                onChange={(e) => handleChange(e, 'description')}
                            // disabled={!isRange ? isClosedReportingMonth : editedItem.isClosedReportingMonth}
                            />
                        </div>
                    </TableCell>

                    {isRange && (
                        <TableCell align="right">
                            {item?.reportingMonthDate ? formatDateNew(item.reportingMonthDate) : '-'}
                        </TableCell>
                    )}
                    <TableCell align="right">{formatDateNew(item?.uploadDate)}</TableCell>
                    <TableCell align="right">{formatDateNew(item?.documentDate)}</TableCell>

                    {/* Amount */}
                    <TableCell align="right">
                        <div className='td-container'>
                            <input
                                type="number"
                                className='edit-input-field-2'
                                value={editedItem.amount || ''}
                                onChange={(e) => handleChange(e, 'amount')}
                            // disabled={!isRange ? isClosedReportingMonth : editedItem.isClosedReportingMonth}
                            />
                        </div>
                    </TableCell>
                    {/* VAT */}
                    <TableCell align="right">
                        <div className='td-container' style={{ display: 'flex', flexDirection: 'row', height: '60%', justifyContent: 'center', alignItems: 'center' }}>
                            <RadioGroup
                                row
                                aria-labelledby="demo-form-control-label-placement"
                                name="position"
                                defaultValue="top"
                                onChange={handleVatRadioChange}
                                style={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
                            >
                                <FormControlLabel
                                    value={16}
                                    control={<Radio />}
                                    label={t('AccountingTax')}
                                    labelPlacement="top"
                                    checked={editedItem.vat === 16}
                                    // disabled={!isRange ? isClosedReportingMonth : editedItem.isClosedReportingMonth}
                                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                                />
                                <FormControlLabel
                                    value={100}
                                    control={<Radio />}
                                    label="100"
                                    labelPlacement="top"
                                    checked={editedItem.vat === 100}
                                    // disabled={!isRange ? isClosedReportingMonth : editedItem.isClosedReportingMonth}
                                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                                />
                                <FormControlLabel
                                    value={66}
                                    control={<Radio />}
                                    label="66"
                                    labelPlacement="top"
                                    checked={editedItem.vat === Constants.Vat66}
                                    // disabled={!isRange ? isClosedReportingMonth : editedItem.isClosedReportingMonth}
                                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                                />
                                <FormControlLabel
                                    value={25}
                                    control={<Radio />}
                                    label="25"
                                    labelPlacement="top"
                                    checked={editedItem.vat === 25}
                                    // disabled={!isRange ? isClosedReportingMonth : editedItem.isClosedReportingMonth}
                                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                                />
                                <FormControlLabel
                                    value={0}
                                    control={<Radio />}
                                    label="0"
                                    labelPlacement="top"
                                    checked={editedItem.vat === 0}
                                    // disabled={!isRange ? isClosedReportingMonth : editedItem.isClosedReportingMonth}
                                    style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}
                                />
                            </RadioGroup>
                        </div>
                    </TableCell>


                    <TableCell align="right">
                        <div className='td-container'>
                            {item.vatAmount !== null ? parseFloat(item.vatAmount).toFixed(2).toLocaleString() : '0.00'}
                        </div>
                    </TableCell>

                    <TableCell align="right">
                        <div className='td-container'>
                            {item.netAmount !== null ? parseFloat(item.netAmount).toFixed(2).toLocaleString() : '0.00'}
                        </div>
                    </TableCell>
                    {/* Credit Account */}
                    <TableCell align="right">
                        <ReactSelect
                            options={creditAccountOptions.map(option => ({ value: option.cardId, label: `${option.cardId} - ${option.name}` }))}
                            value={creditAccountOptions
                                .filter(option => option.cardId === editedItem.creditAccount)
                                .map(option => ({ value: option.cardId, label: `${option.cardId} - ${option.name}` }))[0]}
                            onChange={(selectedOption) => handleChange({ target: { value: selectedOption.value } }, 'creditAccount')}
                            placeholder={t("Select AccountCard")}
                        // isDisabled={!isRange ? isClosedReportingMonthDisplay : editedItem.isClosedReportingMonth}
                        />
                    </TableCell>

                    {/* Debit Account */}
                    <TableCell align="right">
                        <ReactSelect
                            options={debitAccountOptions.map(option => ({ value: option.cardId, label: `${option.cardId} - ${option.name}` }))}
                            value={debitAccountOptions
                                .filter(option => option.cardId === editedItem.debitAccount)
                                .map(option => ({ value: option.cardId, label: `${option.cardId} - ${option.name}` }))[0]}
                            onChange={(selectedOption) => handleChange({ target: { value: selectedOption.value } }, 'debitAccount')}
                            placeholder={t("Select AccountCard")}
                        // isDisabled={!isRange ? isClosedReportingMonthDisplay : editedItem.isClosedReportingMonth}
                        />
                    </TableCell>

                    {/* Sort Code */}
                    <TableCell align="right">
                        <ReactSelect
                            options={sortCodeIdOptions.map(option => ({ value: option.sortCodeId, label: `${option.sortCodeId} - ${option.sortCodeName}` }))}
                            value={sortCodeIdOptions
                                .filter(option => option.sortCodeId === editedItem.sortCodeId)
                                .map(option => ({ value: option.sortCodeId, label: `${option.sortCodeName} - ${option.sortCodeId}` }))[0]}
                            onChange={(selectedOption) => handleChange(selectedOption, 'sortCodeId')}
                            placeholder={t("Select SortCode")}
                        // isDisabled={!isRange ? isClosedReportingMonthDisplay : editedItem.isClosedReportingMonth}
                        />
                    </TableCell>

                    <TableCell align="right">{item.uploadNumber}</TableCell>

                    <TableCell align="right">
                        <div className='row-buttons-container'>
                            <button className='row-buttons' onClick={() => handleUpdate(item.id)}>
                                <img src={saveIcon} alt="Save" className="doc-details-icon" />
                            </button>
                            <button className='row-buttons' onClick={handleCancel}>
                                <img src={cancelIcon} alt="Cancel" className="doc-details-icon" />
                            </button>
                        </div>
                    </TableCell>
                </>
            </TableRow>
        ) : (
            <TableRow key={item.id} sx={{ ...undealtStyle }} selected={isItemSelected} onDoubleClick={handleDoubleClick}>
                {/* View Mode */}
                {!addNewJournalEntry ? (<>
                    <TableCell align="right">
                        {!isIdInChecks ? (
                            <p style={{ color: 'green', fontSize: '16px', fontWeight: 'bold' }}>{t('processed')}</p>
                        ) : (
                            <p style={{ color: 'red', fontSize: '16px', fontWeight: 'bold' }}>{t('unprocessed')}</p>
                        )}
                    </TableCell>
                    <TableCell align="right">{item?.accountCaseId}</TableCell>
                    <TableCell align="right">{item?.reference}</TableCell>
                    <TableCell align="right">{item?.confirmationNumber}</TableCell>

                    <TableCell align="right">{item?.description}</TableCell>
                    {isRange && (
                        <TableCell align="right">
                            {item?.reportingMonthDate ? formatDateNew(item.reportingMonthDate) : '-'}
                        </TableCell>
                    )}
                    <TableCell align="right">{formatDateNew(item?.uploadDate)}</TableCell>
                    <TableCell align="right">{formatDateNew(item?.documentDate)}</TableCell>
                    <TableCell align="right" className="totalPrice-new">
                        <p style={{ color: 'green', fontSize: '16px', fontWeight: 'bold' }}>
                            {item?.amount !== null ? beautifyNumber(item.amount) : '0.00'}
                        </p>
                    </TableCell>
                    <TableCell align="right">{beautifyNumber(item?.vat || 0)}%</TableCell>
                    <TableCell align="right">{beautifyNumber(item?.vatAmount || 0)}</TableCell>
                    <TableCell align="right">{beautifyNumber(item?.netAmount || 0)}</TableCell>
                    <TableCell align="right">{item.creditAccount} - {creditAccountOptions.find(option => option.cardId === item.creditAccount)?.name || item.creditAccount}</TableCell>
                    <TableCell align="right">{item.debitAccount} - {creditAccountOptions.find(option => option.cardId === item.debitAccount)?.name || item.debitAccount}</TableCell>
                    <TableCell align="right">{item.sortCodeId} - {sortCodeIdOptions.find(option => option.sortCodeId === item.sortCodeId)?.sortCodeName || item.sortCodeId}</TableCell>
                    <TableCell align="right">{item.uploadNumber}</TableCell>

                    <TableCell>
                        {(client?.accountManagement === Constants.AccountManagementOptions[0].name
                            ? item.sortCodeId && item.creditAccount && item.debitAccount
                            : item.sortCodeId) && (
                                <div>
                                    <Checkbox
                                        checked={isItemSelected}
                                        onChange={(event) => handleSelectRow(event, item.id)}
                                        sx={{
                                            color: '#E57C22',
                                            '&.Mui-checked': {
                                                color: '#E57C22',
                                            },
                                            display: 'inline-table'
                                        }}
                                    />
                                </div>
                            )}
                        <div className='actions_container'>
                            <button className='row-buttons' onClick={() => handleEdit(item, index)}>
                                <EditIcon className="doc-details-icon" style={{ color: '#E57C22' }} />
                            </button>
                            {/* {(isRange ? !item?.isClosedReportingMonth : !isClosedReportingMonth) && (
                                <button className='row-buttons' onClick={() => handleDeleteClick(item.id)}>
                                    <DeleteIcon className="doc-details-icon" style={{ color: '#E57C22' }} />
                                </button>
                            )} */}
                        </div>
                    </TableCell>
                </>
                ) : (<>
                    <TableCell align="right">{item?.confirmationNumber}</TableCell>
                    <TableCell align="right">{item?.accountCaseId}</TableCell>
                    <TableCell align="right">{item?.reference}</TableCell>
                    <TableCell align="right">{item?.description}</TableCell>
                    <TableCell align="right">{formatDateNew(item?.documentDate)}</TableCell>
                    <TableCell align="right" className="totalPrice-new">
                        <p style={{ color: 'green', fontSize: '16px', fontWeight: 'bold' }}>
                            {item?.amount !== null ? beautifyNumber(item.amount) : '0.00'}
                        </p>
                    </TableCell>
                    <TableCell align="right">{beautifyNumber(item?.vat || 0)}%</TableCell>
                    <TableCell align="right">{item.creditAccount} - {creditAccountOptions.find(option => option.cardId === item.creditAccount)?.name || item.creditAccount}</TableCell>
                    <TableCell align="right">{item.debitAccount} - {creditAccountOptions.find(option => option.cardId === item.debitAccount)?.name || item.debitAccount}</TableCell>
                    <TableCell align="right">{item.sortCodeId} - {sortCodeIdOptions.find(option => option.sortCodeId === item.sortCodeId)?.sortCodeName || item.sortCodeId}</TableCell>
                    <TableCell align="right"></TableCell>



                </>)}
            </TableRow>
        );
    };

    const [selectedValue, setSelectedValue] = useState(null);

    // Function to handle the checkbox click and set the selected value
    const handleCheckboxChange = (value) => {
        //handleInputChange
        if (value === 'accountingTax') {
            handleInputChange('vat', 16)
        }
        handleInputChange('vat', value)
        setSelectedValue(value);  // Update the state with the selected value
    };

    // Memoized rows using the modified Row component
    const memoizedRows = useMemo(() => {

        return filteredAndSortedData.map((item, index) => (
            <Row item={item} index={index} />
        ));
    }, [filteredAndSortedData, addNewJournalEntry, selectedRows]);

    const commonStyles = {
        height: '40px',            // Set the height
        width: '160px',
        backgroundColor: '#fff',   // Set background to white
        padding: '0 10px'          // Adjust padding
    };


    const handleDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), sortDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(sortDate.getFullYear(), newDate.getMonth(), 10));
        }

        setSortDate(updatedDate);

        // Save the updated date in localStorage for persistence
        localStorage.setItem('Date', updatedDate);
        await fetchDocuments(updatedDate);
    };

    const handleStartDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), startDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(startDate.getFullYear(), newDate.getMonth(), 10));
        }


        // Save the updated date in localStorage for persistence
        localStorage.setItem('StartDate', updatedDate)

        setStartDate(updatedDate);
        if (isRange) {
            await fetchDataOnDateRangeChange(new Date(updatedDate), new Date(endDate));
        }
    };

    const handleEndDateChangeNew = async (newValue, type) => {
        const newDate = new Date(newValue);
        let updatedDate;

        if (type === 'year') {
            updatedDate = new Date(Date.UTC(newDate.getFullYear(), endDate.getMonth(), 10));
        } else if (type === 'month') {
            updatedDate = new Date(Date.UTC(endDate.getFullYear(), newDate.getMonth(), 10));
        }


        // Save the updated date in localStorage for persistence
        localStorage.setItem('EndDate', updatedDate)

        setEndDate(updatedDate);
        if (isRange) {
            await fetchDataOnDateRangeChange(new Date(startDate), new Date(updatedDate));
        }
    };

    const fileInputRef = useRef();
    const {
        viewDocumentDetails,
        viewPaymentAcceptanceDetails,
        viewJournalEntryDetails,
    } = useClientNavigation(client);

    // Keyboard shortcuts for navigation

    // Function to download selected rows as XLSX
    const handleDownloadSelectedRowsAsExcel = () => {
        // Get rows to export - if none selected, export all rows
        const rowsToExport = selectedRows.length > 0
            ? data.filter(row => selectedRows.includes(row.id))
            : filteredAndSortedData;

        if (rowsToExport.length === 0) {
            toast.info(t('NoDataToDownload'));
            return;
        }

        // Define headers mapping
        const headers = {
            accountCaseId: t('CompanyId'),
            reference2: t('Reference2'),
            reference: t('Reference'),
            confirmationNumber: t('ConfirmationNumber'),
            description: t('Description'),
            reportingMonthDate: t('MonthReportDate'),
            uploadDate: t('RegistrationDate'),
            documentDate: t('ValueDate'),
            amount: t('Amount'),
            vat: t('VAT'),
            vatAmount: t('VATAmount'),
            netAmount: t('NetAmount'),
            creditAccount: t('Credit Account'),
            debitAccount: t('Debit Account'),
            sortCodeId: t('Code ID'),
            uploadNumber: t('UploadNumber'),
        };

        // Transform the data for Excel export
        const excelData = rowsToExport.map(row => {
            const transformedRow = {};

            // Map each field with proper formatting
            Object.keys(headers).forEach(key => {
                if (key === 'uploadDate' || key === 'documentDate') {
                    transformedRow[headers[key]] = row[key] ? formatDateNew(row[key]) : '';
                } else if (key === 'reportingMonthDate') {
                    transformedRow[headers[key]] = row[key] ? formatMonthYearDate(row[key]) : '';
                } else if (key === 'amount' || key === 'vatAmount' || key === 'netAmount') {
                    // Format numbers to 2 decimal places
                    transformedRow[headers[key]] = row[key] !== null && row[key] !== undefined
                        ? Math.round((parseFloat(row[key]) || 0) * 100) / 100
                        : 0;
                } else if (key === 'creditAccount' || key === 'debitAccount') {
                    // Get account name if available
                    const option = key === 'creditAccount'
                        ? creditAccountOptions.find(opt => opt.cardId === row[key])
                        : debitAccountOptions.find(opt => opt.cardId === row[key]);
                    transformedRow[headers[key]] = option && row[key]
                        ? `${row[key]} - ${option.name}`
                        : row[key] || '';
                } else if (key === 'sortCodeId') {
                    // Get sort code name if available
                    const option = sortCodeIdOptions.find(opt => opt.sortCodeId === row[key]);
                    transformedRow[headers[key]] = option && row[key]
                        ? `${row[key]} - ${option.sortCodeName}`
                        : row[key] || '';
                } else {
                    transformedRow[headers[key]] = row[key] || '';
                }
            });

            return transformedRow;
        });

        // Create workbook and worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'JournalEntries');

        // Generate filename with current date and client info
        const dateStr = new Date().toISOString().split('T')[0];
        const filename = `${client?.caseId || 'JournalEntries'}_${dateStr}.xlsx`;

        // Download the file
        XLSX.writeFile(wb, filename);

        toast.success(t('ExcelFileDownloadedSuccessfully') || 'Excel file downloaded successfully');
    };

    const handleBulkDeleteDocuments = async () => {
        if (selectedRows.length === 0) return;

        const confirm = await Swal.fire({
            title: t('DeleteDocumentsConfirm', { count: selectedRows.length }),
            text: t('ThisActionCannotBeUndone'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: t('YesDelete'),
            cancelButtonText: t('Cancel')
        });
        if (!confirm.isConfirmed) return;

        setLocalLoading(true);
        const res = await DocumentService.BulkDeleteDocuments(
            type,
            selectedRows,
            client.caseId,
            token
        );
        res.ok ? toast.success(t('documentDeleteSuccess'))
            : toast.error(t('documentDeleteError'));
        await RefreshPage();
        setLocalLoading(false);
        setSelectedRows([]);
    };

    const handleBulkPatchDocuments = async (patchOrPatches) => {
        setLocalLoading(true);
        const {
            flipAmount,
            flipCards,
            replaceDescriptionWithAccountName,
            syncProject,
            projectId,
            alignRegistrationMonthToDocumentDate,
            ...patch
        } = patchOrPatches || {};
        const res = await DocumentService.BulkUpdateDocuments(
            type,
            selectedRows,
            patch,
            client.caseId,
            token,
            {
                flipAmount: !!flipAmount,
                flipCards: !!flipCards,
                replaceDescriptionWithAccountName: !!replaceDescriptionWithAccountName,
                syncProject: !!syncProject,
                projectId: syncProject ? (projectId ?? null) : undefined,
                alignRegistrationMonthToDocumentDate: !!alignRegistrationMonthToDocumentDate,
            }
        );
        res.ok ? toast.success(t('documentUpdateSuccess'))
            : toast.error(t('documentUpdateError'));
        await RefreshPage();
        setLocalLoading(false);
        setSelectedRows([]);
    };

    const buttonData = useMemo(() => {
        const canSeeBulkActions =
            userTypeContext?.toString() !== Constants.UserType.Client || permissionsState.Premium;

        return [
            {
                label: 'Downloads',
                isDropdown: true,
                iconColor: 'green',
                dropdownItems: [
                    {
                        label: 'DownloadSelectedDocuments',
                        onClick: () => handleDownloadMergedDocuments(),
                        tooltip: selectedRows.length > 0
                            ? `${t('DownloadSelectedDocuments')} (${selectedRows.length})`
                            : t('DownloadSelectedDocuments'),
                        disabled: selectedRows.length === 0 || loading,
                        show: canSeeBulkActions,
                    },
                    {
                        label: 'DownloadReceptionLog',
                        displayLabel: selectedRows.length > 0
                            ? t('DownloadSelectedRowsDocumentation', { count: selectedRows.length }) ||
                                `${t('DownloadReceptionLog')} (${selectedRows.length})`
                            : t('DownloadReceptionLog'),
                        onClick: handleDownloadJournalEntryDocumentation,
                        tooltip: selectedRows.length > 0
                            ? t('DownloadSelectedRowsDocumentation', { count: selectedRows.length }) ||
                                `${t('DownloadReceptionLog')} (${selectedRows.length})`
                            : t('DownloadReceptionLog'),
                        disabled: selectedRows.length === 0 || loading,
                        show: canSeeBulkActions,
                    },
                    {
                        label: 'DownloadExcelFile',
                        onClick: handleDownloadSelectedRowsAsExcel,
                    },
                ],
            },
            {
                label: 'Actions',
                isDropdown: true,
                iconColor: 'green',
                dropdownItems: [
                    {
                        label: 'AddNewJournalEntry',
                        onClick: () => {
                            if (client?.isActive === false) {
                                toast.error(t('ClientInactiveCannotCreateDocuments'));
                                return;
                            }
                            const sendData = {
                                accountCodeName: '',
                                accountCaseId: '',
                                accountCodeId: '',
                                reference: '',
                                description: '',
                                uploadDate: new Date(),
                                documentDate: new Date(),
                                amount: '',
                                vat: 0,
                                creditAccount: '',
                                debitAccount: '',
                                sortCodeId: '3',
                                processed: false,
                                registrationMonthDate: new Date(sortDate).toISOString(),
                                reportingMonthDate: new Date(sortDate).toISOString(),
                            };
                            setCurrentRowData(sendData);
                            setIsAddMode(true);
                            setOpenInlineEditModal(true);
                        },
                        show: client?.isActive !== false,
                    },
                    {
                        label: 'ImportManifestEntry',
                        onClick: () => {
                            if (client?.isActive === false) {
                                toast.error(t('ClientInactiveCannotCreateDocuments'));
                                return;
                            }
                            setShowImportManifestModal(true);
                        },
                        show: client?.isActive !== false,
                        icon: () => (
                            <img
                                src={ImportManifestEntryModalIcon}
                                alt="Import Manifest"
                                style={{ width: '18px', height: '18px' }}
                            />
                        ),
                    },
                    {
                        label: 'JournalEntryTemplates',
                        onClick: () => setShowJournalTemplatesModal(true),
                    },
                    {
                        label: 'VatClosing',
                        onClick: () => {
                            if (client?.isActive === false) {
                                toast.error(t('ClientInactiveCannotCreateDocuments'));
                                return;
                            }
                            setShowVatClosingModal(true);
                        },
                        show: client?.isActive !== false,
                    },
                    {
                        label: 'PayrollJournalEntries',
                        onClick: () => {
                            if (client?.isActive === false) {
                                toast.error(t('ClientInactiveCannotCreateDocuments'));
                                return;
                            }
                            setShowPayrollModal(true);
                        },
                        show: client?.isActive !== false,
                    },
                    {
                        label: 'ImportZReport',
                        onClick: () => {
                            if (client?.isActive === false) {
                                toast.error(t('ClientInactiveCannotCreateDocuments'));
                                return;
                            }
                            setShowZReportModal(true);
                        },
                        show: client?.isActive !== false,
                    },
                    {
                        label: 'EditJournalEntryType',
                        onClick: () => setIsEditJournalEntryTypeModalOpen(true),
                        disabled: selectedRows.length === 0,
                    },
                    {
                        label: 'ShowDuplicates',
                        onClick: () => setShowDuplicatesModal(true),
                    },
                    {
                        label: 'BulkEdit',
                        onClick: () => setBulkEditOpen(true),
                        disabled: selectedRows.length === 0 || loading,
                    },
                    {
                        label: 'BulkDelete',
                        onClick: () => handleBulkDeleteDocuments(),
                        disabled: selectedRows.length === 0 || loading,
                        danger: true,
                    },
                    {
                        label: 'CommandStatus',
                        onClick: setOpenOption,
                        disabled:
                            allowAllSelect ||
                            (selectedRows.length === 0 && !complexDepositsChecked) ||
                            (complexDepositsChecked && (debitCreditSum !== 0 || selectedRows.length === 0)),
                        show: canSeeBulkActions,
                    },
                ],
            },
        ];
    }, [
        userTypeContext,
        permissionsState.Premium,
        selectedRows,
        loading,
        t,
        client?.isActive,
        sortDate,
        allowAllSelect,
        complexDepositsChecked,
        debitCreditSum,
    ]);

    // const jumpButtons = useMemo(() => {
    //     const map = {
    //       Incomes: [
    //         {
    //           label: 'Expenses',
    //           onClick: () => viewDocumentDetails('Expenses'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',  
    //         },
    //         {
    //           label: 'PaymentAcceptance',
    //           onClick: () => viewPaymentAcceptanceDetails('PaymentAcceptances'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',              },
    //       ],
    //       Expenses: [
    //         {
    //           label: 'Incomes',
    //           onClick: () => viewDocumentDetails('Incomes'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',              },
    //         {
    //           label: 'PaymentAcceptance',
    //           onClick: () => viewPaymentAcceptanceDetails('PaymentAcceptances'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',              },
    //       ],
    //       PaymentAcceptances: [
    //         {
    //           label: 'Expenses',
    //           onClick: () => viewDocumentDetails('Expenses'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',              },
    //         {
    //           label: 'Incomes',
    //           onClick: () => viewDocumentDetails('Incomes'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',              },

    //       ],
    //       JournalEntries: [
    //         {
    //           label: 'Expenses',
    //           onClick: () => viewDocumentDetails('Expenses'),
    //           style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //           className: 'journal-btn',              },
    //     {
    //         label: 'Incomes',
    //         onClick: () => viewDocumentDetails('Incomes'),
    //         style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //         className: 'journal-btn',              },
    //         {
    //         label: 'PaymentAcceptance',
    //         onClick: () => viewPaymentAcceptanceDetails('PaymentAcceptances'),
    //         style: { width: '100px',backgroundColor: '#f9aa2a', justifyContent: 'center' },
    //         className: 'journal-btn',  
    //         },
    //       ]
    //     };

    //     return map[type] ?? [];
    //   }, [type, viewDocumentDetails, viewPaymentAcceptanceDetails]);
    // const buttonData = [...baseButtons, ...jumpButtons];

    const formattedAccountCardOptions = creditAccountOptions.map((option) => ({
        value: option.cardId,
        label: option.accountCaseId
            ? `${option.name} - ${option?.accountCaseId || ''}`
            : `${option.name}`,
        name: option.name,
        accountCaseId: option.accountCaseId || '',
        cardId: option.cardId,
        value1: option.value1,
        palCode: option.palCode,
        isEditable: option.isEditable
    }));

    const formattedAccountCardOptionsForImportManifest = accountCardOptions
        .map(option => ({
            value: option.cardId,
            label: option.accountCaseId
                ? `${option.name} - ${option.accountCaseId}`
                : `${option.name}`,
            name: option.name,
            accountCaseId: option.accountCaseId || '',
            cardId: option.cardId,
            value1: option.value1,
            palCode: option.palCode,
            isEditable: option.isEditable
        }));



    useEffect(() => {
        if (accountCardOptions && accountCardOptions.length > 0) {
            const maxCardId = Math.max(...accountCardOptions.slice(1).map((option) => parseInt(option.cardId, 10)));
            setCardIdOption(maxCardId + 1);
        }
    }, [accountCardOptions]);

    return (
        <>
            <DraggableModal
                bigIframeModalOpen={bigIframeModalOpen}
                openedIframeUrl={openedIframeUrl}
                handleCloseIframeModal={handleCloseIframeModal}
            />
            {/* <HamburgerMenu client={client} /> */}

            <AssetFoundDialog
                open={showAssetFoundDialog}
                asset={foundAsset}
                assetGroups={assetGroups}
                onClose={() => setShowAssetFoundDialog(false)}
                isDraggable={true}            // or false if you don't want drag
                caseId={client?.caseId}
                token={token}
                transactionId={editedItem.id}
                fetchEnums={fetchEnumsNoParams}
            />


            <>
                <>
                    {/* NavigationButton and Journal Entry Type Filter in same row */}
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        flexWrap: 'wrap',
                    }}
                        dir={direction}
                    >
                        <NavigationButton
                            t={t}
                            direction={direction}
                            selectedRows={selectedRows}
                            fileInputRef={fileInputRef}
                            data={buttonData}
                        />

                        {/* Journal Entry Type Filter */}
                        <JournalEntryTypeFilter
                            t={t}
                            direction={direction}
                            selectedJournalEntryTypes={selectedJournalEntryTypes}
                            setSelectedJournalEntryTypes={setSelectedJournalEntryTypes}
                            journalEntryTypeDropdownOpen={journalEntryTypeDropdownOpen}
                            setJournalEntryTypeDropdownOpen={setJournalEntryTypeDropdownOpen}
                            journalEntryTypeOptions={journalEntryTypeOptions}
                        />
                    </Box>

                    <div className={`searchFilter-bar__container document-toolbar-row ${direction}${complexDepositsChecked ? ' has-complex-totals' : ''}`}>
                        <Box className="document-filter-row" dir={direction}>
                            <TextField
                                size="small"
                                dir={direction}
                                placeholder={t('Search')}
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                                className="document-search-bar"
                                variant="standard"
                                InputProps={{
                                    disableUnderline: true,
                                    className: `custom-input-box-sizing ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon className="document-search-icon" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                            <label className={`${headerStyles.switchRow} ${headerStyles[direction] || ''}`} dir={direction}>
                                <span>{t('DateRange')}</span>
                                <input
                                    type="checkbox"
                                    checked={isRange}
                                    onChange={handleRangeChange}
                                />
                                <span className={headerStyles.switchTrack} aria-hidden="true" />
                            </label>

                            {isRange ? (
                                <div className={headerStyles.dateSelectRange}>
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={startDate}
                                            month={startDate}
                                            onYearChange={(newYear) => handleStartDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleStartDateChangeNew(newMonth, 'month')}
                                            labelYear={t('StartYear')}
                                            labelMonth={t('StartMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                    <div className={headerStyles.rangeDivider} />
                                    <div className={headerStyles.dateSelect}>
                                        <FilterMonthYearPicker
                                            year={endDate}
                                            month={endDate}
                                            onYearChange={(newYear) => handleEndDateChangeNew(newYear, 'year')}
                                            onMonthChange={(newMonth) => handleEndDateChangeNew(newMonth, 'month')}
                                            labelYear={t('EndYear')}
                                            labelMonth={t('EndMonth')}
                                            direction={direction}
                                        />
                                    </div>
                                </div>
                            ) : (
                                <div className={headerStyles.dateSelect}>
                                    <FilterMonthYearPicker
                                        year={sortDate}
                                        month={sortDate}
                                        onYearChange={(newYear) => handleDateChangeNew(newYear, 'year')}
                                        onMonthChange={(newMonth) => handleDateChangeNew(newMonth, 'month')}
                                        labelYear={t('Year')}
                                        labelMonth={t('Month')}
                                        direction={direction}
                                    />
                                </div>
                            )}

                            <Box className="document-data-view">
                                <span className="document-data-view__label">{t('DataView')}</span>
                                <ToggleButtonGroup
                                    value={useRegistrationMonth ? 'registration' : 'reporting'}
                                    exclusive
                                    onChange={(event, newValue) => {
                                        if (newValue !== null) {
                                            const isRegistration = newValue === 'registration';
                                            setUseRegistrationMonth(isRegistration);
                                            localStorage.setItem('UseRegistrationMonth', isRegistration.toString());
                                        }
                                    }}
                                    size="small"
                                >
                                    <ToggleButton value="reporting" aria-label="reporting month">
                                        {t('ReportingMonth')}
                                    </ToggleButton>
                                    <ToggleButton value="registration" aria-label="registration month">
                                        {t('RegistrationMonth')}
                                    </ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </Box>
                        <Box className="document-mode-toggles">
                            <Box className="document-mode-toggle-stack">
                                <Box className={`document-mode-toggle${complexDepositsChecked ? ' is-checked' : ''}`}>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                checked={complexDepositsChecked}
                                                onChange={(e) => setComplexDepositsChecked(e.target.checked)}
                                                inputProps={{ 'aria-label': t('HandlingComplexDeposits') }}
                                                size="small"
                                            />
                                        }
                                        label={t('HandlingComplexDeposits')}
                                    />
                                </Box>
                                {complexDepositsChecked && (
                                    <span className="document-mode-toggle__totals">
                                        {t('TotalCredit')}: {beautifyNumber(creditSum)} · {t('TotalDebit')}: {beautifyNumber(debitSum)} · {t('Difference')}: {beautifyNumber(debitCreditSum)}
                                    </span>
                                )}
                            </Box>

                            <Box
                                className={`document-mode-toggle${allowAllSelect ? ' is-checked' : ''}`}
                                data-testid="handle-all-commands-container"
                            >
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            data-testid="handle-all-commands-checkbox"
                                            inputProps={{ 'data-testid': 'handle-all-commands-checkbox-input' }}
                                            checked={allowAllSelect}
                                            onChange={(e) => setAllowAllSelect(e.target.checked)}
                                            size="small"
                                        />
                                    }
                                    label={t('HandleAllCommands')}
                                />
                            </Box>
                            <Box className={`document-mode-toggle${showOnlyUnprocessed ? ' is-checked' : ''}`}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={showOnlyUnprocessed}
                                            onChange={(e) => setShowOnlyUnprocessed(e.target.checked)}
                                            inputProps={{ 'aria-label': t('ShowUnprocessedDocuments') }}
                                            size="small"
                                        />
                                    }
                                    label={t('ShowUnprocessedDocuments')}
                                />
                            </Box>
                        </Box>
                    </div>
                    <div className="document-kpi-strip" dir={direction}>
                        <DocumentKpiCards
                            direction={direction}
                            vatHeaders={denseTableHeader}
                            vatRows={denseTableRows}
                            ledgerHeaders={denseTableCreditDebitHeader}
                            ledgerRows={denseTableCreditDebitRows}
                        />
                    </div>
                    <MissingAccountCardsAlert
                        missingCards={missingAccountCards}
                        direction={direction}
                        client={client}
                        token={token}
                        palCodes={formattedPalCodeOptions}
                        accountCardOptions={accountCardOptions}
                        fetchEnums={fetchEnumsNoParams}
                        setLocalLoading={setLocalLoading}
                        isRange={isRange}
                        isClosedReportingMonth={isClosedReportingMonthDisplay}
                        sortCodes={sortCodeIdOptions}
                    />
                        <InactiveClientAlert client={client} />

                    <SelectDocumentOptionDialog
                        open={openOptions}
                        onClose={closeOptions}
                        onOptionSelect={handleOptionSelect}
                        splitInfo={splitInfo}
                        selectedRowsNumber={selectedRows.length}
                    />


                    <JournalEntryDataGrid
                        ref={dataGridRef}
                        t={t}
                        client={client}
                        data={filteredAndSortedData}
                        isRange={isRange}
                        isClosedReportingMonth={false}
                        subAccountantOptions={subAccountantOptions}
                        accountCardOptions={accountCardOptions}
                        creditAccountOptions={creditAccountOptions}
                        debitAccountOptions={debitAccountOptions}
                        sortCodeIdOptions={sortCodeIdOptions}
                        formatDateNew={formatDateNew}
                        formatMonthYearDate={formatMonthYearDate}
                        beautifyNumber={beautifyNumber}
                        Constants={Constants}
                        handleDeleteClick={handleDeleteClick}
                        handleSave={handleNormalSave}
                        handleCancel={handleCancel}
                        direction={direction}
                        setEditedItem={setEditedItem}
                        editedItem={editedItem}
                        setEditedPopupItem={setEditedPopupItem}
                        handleEdit={handleEdit}
                        setCurrentRowData={setCurrentRowData}
                        setOpenInlineEditModal={setOpenInlineEditModal}
                        handleSelectRows={handleSelectRows}
                        addNewJournalEntry={addNewJournalEntry}
                        setAddNewJournalEntry={setAddNewJournalEntry}
                        openPdfInNewTab={openPdfInNewTab}
                        handleOpenDialog={handleOpenDialog}
                        handleRightClickAction={handleRightClickAction}
                        complexDepositsChecked={complexDepositsChecked}
                        setDebitCreditSum={setDebitCreditSum}
                        setCreditSum={setCreditSum}
                        setDebitSum={setDebitSum}
                        allowAllSelect={allowAllSelect}
                        sortDate={sortDate}
                        startDate={startDate}
                        endDate={endDate}
                        token={token}
                        filteredAndSortedData={filteredAndSortedData}
                        handleReopenEdit={handleReopenEdit}
                        fetchEnums={fetchEnumsForceRefetch}
                        palCodes={formattedPalCodeOptions}
                        palCode={palCode}
                        setPalCode={setPalCode}
                        setLoading={setLocalLoading}
                        byProjectsFilterActive={byProjectsFilterActive}
                        onByProjectsFilterToggle={handleByProjectsFilterToggle}
                        loadingSegmentations={loadingSegmentations}
                        projectAutocompleteOptions={segmentationProjects}
                        selectedFromSegmentation={selectedFromSegmentation}
                        selectedToSegmentation={selectedToSegmentation}
                        onFromSegmentationChange={handleFromSegmentationChange}
                        onToSegmentationChange={handleToSegmentationChange}
                        onFilteredRowsChange={handleGridFilteredRowsChange}
                    />

                </>



                {showChooseAsset && (
                    <ChooseAsset
                        date={dateForAsset}
                        open={showChooseAsset}
                        editedItemVat={editedItem.vat}
                        onClose={() => handleAssetClose()}
                        type={editedItem?.docType}
                        itemId={itemToAddToAsset}
                        client={client}
                        token={token}
                        onAssetChosen={(assetId) => {
                            setShowChooseAsset(false);
                        }}
                        onCreateAsset={(newAsset) => {
                            setShowChooseAsset(false);
                        }}
                        fullItem={itemForAssets}
                        saleEquipment={saleEquipment}
                        clickedAsset={clickedAsset}
                        fetchEnums={fetchEnums}
                        user={user}
                        setShowAddGroupModal={handleOpenGroudAdd}
                        assetGroups={assetGroups}

                    />
                )}

                {showAddGroupModal && (
                    <AddAssetGroup
                        open={showAddGroupModal}
                        onClose={() => setShowAddGroupModal(false)}
                        caseId={client.caseId}
                        token={token}
                        assetGroups={assetGroups}
                        refreshAssetGroups={() => {
                            // Refresh the list
                            fetchEnums(user, token, client);
                            setShowAddGroupModal(false);
                        }}
                    />
                )}
                <CustomDeleteConfirmationModal
                    isVisible={isModalVisible}
                    onClose={() => setIsModalVisible(false)}
                    onDelete={handleConfirm}
                    confirmMessage={getConfirmMessage()}
                    titleMessage={getTitleMessage()}
                    type={actionType}
                />
                <ToastContainer position={direction === 'rtl' ? 'top-left' : 'top-right'} rtl={direction === 'rtl'} />
                {showPageLoadingOverlay && (
                    <div className="loader-container">
                        <PuffLoader
                            size={100}        // Larger size for better visibility
                            loading={showPageLoadingOverlay}
                        />
                    </div>
                )}

                {editedItem && editedPopupItem && Object.keys(editedItem).length > 0 && (

                    <EditModal
                        editedItem={editedItem}
                        fade={fade}
                        subAccountantOptions={subAccountantOptions}
                        handlePrevious={handlePrevious}
                        handleNext={handleNext}
                        currentIndex={currentIndex}
                        filteredAndSortedData={denseTableSource}
                        NoDocumentsPdf={NoDocumentsPdf}
                        t={t}
                        handleAccountChange={handleAccountChange}
                        isRange={isRange}
                        isClosedReportingMonth={false}
                        accountCardOptions={accountCardOptions}
                        handleChange={handleChange}
                        handleDateChange={handleDateChange}
                        CustomInput2={CustomInput2}
                        setReportingMonthDate={setReportingMonthDate}
                        handleVatRadioChange={handleVatRadioChange}
                        statusCheck={statusCheck}
                        handleRadioChange={handleRadioChange}
                        type={type}
                        editedAddAccountCard={editedAddAccountCard}
                        handleCloseEditAddNewAccountCardDocument={handleCloseEditAddNewAccountCardDocument}
                        handleEditAddAccountChange={handleEditAddAccountChange}
                        sortCodeIdOptions={sortCodeIdOptions}
                        debitAccountOptions={debitAccountOptions}
                        creditAccountOptions={creditAccountOptions}
                        handleUpdate={handleUpdate}
                        handleCancel={handleCancel}
                        handleDeleteClick={handleEditDeleteClick}
                        client={client}
                        token={token}
                        setAccountCardOptions={setAccountCardOptions}
                        setLoading={setLocalLoading}
                        setEditedAddAccountCard={setEditedAddAccountCard}
                        setEditedItem={setEditedItem}
                        handleReopenEdit={handleReopenEdit}
                        palCodes={formattedPalCodeOptions}
                        RefreshPage={RefreshPage}
                        handleAccountCardSave={handleAccountCardSave}
                        showIframe={true}
                        fetchEnums={fetchEnumsForceRefetch}
                        assets={assets}
                        assetClicked={handleAssetClicked}
                        accountCards={filteredAndSortedData}
                        hideStatus={hideStatusBadge}
                        showForceProcess={true}
                    />

                )}
                <JournalEntryDraggableDialog
                    open={openInlineEditModal}
                    onClose={handleDialogClose}
                    data={currentRowData}
                    onSave={handleDialogSave}
                    sortDate={sortDate} // Add sortDate prop

                    fade={fade}
                    handlePrevious={handlePrevious}
                    handleNext={handleNext}
                    currentIndex={currentIndex}
                    filteredAndSortedData={denseTableSource}
                    NoDocumentsPdf={NoDocumentsPdf}
                    t={t}
                    handleAccountChange={handleAccountChange}
                    isRange={isRange}
                    isClosedReportingMonth={false}
                    accountCardOptions={accountCardOptions}
                    handleChange={handleChange}
                    handleDateChange={handleDateChange}
                    CustomInput2={CustomInput2}
                    setReportingMonthDate={setReportingMonthDate}
                    handleVatRadioChange={handleVatRadioChange}
                    statusCheck={statusCheck}
                    handleRadioChange={handleRadioChange}
                    type={type}
                    editedAddAccountCard={editedAddAccountCard}
                    handleCloseEditAddNewAccountCardDocument={
                        handleCloseEditAddNewAccountCardDocument
                    }
                    handleEditAddAccountChange={handleEditAddAccountChange}
                    sortCodeIdOptions={sortCodeIdOptions}
                    debitAccountOptions={debitAccountOptions}
                    creditAccountOptions={creditAccountOptions}
                    handleUpdate={handleUpdate}
                    handleCancel={handleCancel}
                    handleDeleteClick={handleEditDeleteClick}
                    client={client}
                    token={token}
                    setAccountCardOptions={setAccountCardOptions}
                    setLoading={setLocalLoading}
                    setEditedAddAccountCard={setEditedAddAccountCard}
                    setEditedItem={setEditedItem}
                    handleReopenEdit={handleReopenEdit}
                    palCodes={formattedPalCodeOptions}
                    RefreshPage={RefreshPage}
                    showIframe={false}
                    fetchEnums={fetchEnumsForceRefetch}
                    Constants={Constants}
                    direction={direction}
                    isAddMode={isAddMode}
                />

                <ImportManifestEntryModal
                    open={showImportManifestModal}
                    onClose={() => setShowImportManifestModal(false)}
                    direction={direction}
                    t={t}
                    client={client}
                    token={token}
                    accountCardOptions={formattedAccountCardOptionsForImportManifest}
                    sortCodeIdOptions={sortCodeIdOptions}
                    year={isRange ? startDate.getFullYear() : sortDate.getFullYear()}
                    month={isRange ? startDate.getMonth() + 1 : sortDate.getMonth() + 1}
                    onDataRefresh={RefreshPage}
                    fetchEnums={fetchEnumsNoParams}
                    setLocalLoading={setLocalLoading}
                    palCodes={formattedPalCodeOptions}
                    onAccountCardAdded={handleImportManifestAccountCardAdded}
                />

                <JournalEntryTemplatesModal
                    open={showJournalTemplatesModal}
                    onClose={() => setShowJournalTemplatesModal(false)}
                    caseId={client?.caseId}
                    accountantId={client?.accountantId}
                    token={token}
                    direction={direction}
                    sortDate={sortDate}
                    debitAccountOptions={debitAccountOptions}
                    creditAccountOptions={creditAccountOptions}
                    sortCodeIdOptions={sortCodeIdOptions}
                    onApplied={RefreshPage}
                />

                <VatClosingJournalModal
                    open={showVatClosingModal}
                    onClose={() => setShowVatClosingModal(false)}
                    client={client}
                    token={token}
                    direction={direction}
                    accountCardOptions={accountCardOptions}
                    settings={caseSystemSettings}
                    onCreated={RefreshPage}
                />

                <PayrollJournalModal
                    open={showPayrollModal}
                    onClose={() => setShowPayrollModal(false)}
                    client={client}
                    token={token}
                    direction={direction}
                    accountCardOptions={accountCardOptions}
                    sortCodeIdOptions={sortCodeIdOptions}
                    settings={caseSystemSettings}
                    fetchEnums={fetchEnumsNoParams}
                    defaultDate={sortDate}
                    onCreated={RefreshPage}
                />

                <ZReportImportModal
                    open={showZReportModal}
                    onClose={() => setShowZReportModal(false)}
                    client={client}
                    token={token}
                    direction={direction}
                    accountCardOptions={accountCardOptions}
                    sortCodeIdOptions={sortCodeIdOptions}
                    onCreated={RefreshPage}
                />

                {bulkEditOpen && (
                    <BulkEditModal
                        open={bulkEditOpen}
                        ids={selectedRows}
                        onClose={() => setBulkEditOpen(false)}
                        onSavePatch={handleBulkPatchDocuments}
                        formattedAccountCardOptions={formattedAccountCardOptions}
                        sortCodeIdOptions={sortCodeIdOptions}
                        client={client}
                        type={type}
                        accountCardOptions={accountCardOptions}
                        token={token}
                        lockedSelection={
                            selectedRows.length > 0 &&
                            selectedRows.every((id) =>
                                filteredAndSortedData.some((row) => row.id === id && row.isLocked)
                            )
                        }
                    />
                )}

                <DuplicateEntriesModal
                    open={showDuplicatesModal}
                    onClose={() => setShowDuplicatesModal(false)}
                    t={t}
                    direction={direction}
                    creditAccountOptions={creditAccountOptions}
                    debitAccountOptions={debitAccountOptions}
                    loading={loading}
                    fetchDuplicates={async (filter) =>
                        DocumentService.FindDuplicates(
                            client.caseId,
                            type,
                            isRange ? startDate : sortDate,
                            isRange ? endDate : sortDate,
                            token,
                            {
                                isRange,
                                useRegistrationMonth,
                                referenceLastDigits: filter?.referenceLastDigits ?? null,
                            }
                        )
                    }
                    onDeleteMany={async (ids, { keptIdsWithDuplicateDescription, selectedByDocType, keptByDocType } = {}) => {
                        setLocalLoading(true);
                        try {
                            const deleteGroups = selectedByDocType && Object.keys(selectedByDocType).length
                                ? selectedByDocType
                                : { [type]: ids };
                            let anyOk = false;
                            let anyFail = false;
                            for (const [docType, typeIds] of Object.entries(deleteGroups)) {
                                if (!typeIds?.length) continue;
                                const res = await DocumentService.BulkDeleteDocuments(
                                    docType,
                                    typeIds,
                                    client.caseId,
                                    token
                                );
                                if (res.ok) anyOk = true;
                                else anyFail = true;
                            }
                            if (anyOk) toast.success(t('documentDeleteSuccess'));
                            if (anyFail) toast.error(t('documentDeleteError'));

                            const clearGroups = keptByDocType && Object.keys(keptByDocType).length
                                ? keptByDocType
                                : (keptIdsWithDuplicateDescription?.length
                                    ? { [type]: keptIdsWithDuplicateDescription }
                                    : {});
                            for (const [docType, typeIds] of Object.entries(clearGroups)) {
                                if (!typeIds?.length) continue;
                                await DocumentService.BulkUpdateDocuments(
                                    docType,
                                    typeIds,
                                    { description: '' },
                                    client.caseId,
                                    token
                                );
                            }
                            await RefreshPage();
                        } catch (err) {
                            toast.error(t('documentDeleteError'));
                        }
                        setLocalLoading(false);
                    }}
                />

                <JournalDocumentationModal
                    open={openJournalDocModal}
                    onClose={() => setOpenJournalDocModal(false)}
                    onSubmit={onSubmitJournalDocumentation}
                    initialTypes={type ? [type.toLowerCase()] : []}
                    initialSortBy={'uploadNumber'}
                    initialSortDirection={'asc'}
                    initialFormat={'pdf'}
                    initialStartDate={isRange ? startDate : sortDate}
                    initialEndDate={isRange ? endDate : sortDate}
                    initialIsRange={isRange}
                    selectedRows={selectedRows}
                    accountCardOptions={creditAccountOptions || []}
                    sortCodeOptions={sortCodeIdOptions || []}
                    direction={direction}
                />

                {/* Edit Journal Entry Type Modal */}
                <Dialog
                    open={isEditJournalEntryTypeModalOpen}
                    onClose={() => {
                        setIsEditJournalEntryTypeModalOpen(false);
                        setSelectedJournalEntryTypeForBulk(0); // Reset on close
                    }}
                    maxWidth="sm"
                    fullWidth
                >
                    <DialogTitle>
                        <Typography variant="h6" component="div" sx={{ fontWeight: 'bold', textAlign: 'center' }}>
                            {t('EditJournalEntryType')}
                        </Typography>
                    </DialogTitle>
                    <DialogContent>
                        <Box dir={direction} sx={{ padding: '20px' }}>
                            <Typography variant="body2" sx={{ marginBottom: '16px', color: '#666' }}>
                                {t('SelectedEntriesCount')}: {selectedRows.length}
                            </Typography>
                            <FormControl fullWidth variant="standard">
                                <Typography variant="body2" sx={{ marginBottom: '8px', fontWeight: 600 }}>
                                    {t('JournalEntryType')}
                                    <span style={{ color: 'red' }}> *</span>
                                </Typography>
                                <Select
                                    fullWidth
                                    value={selectedJournalEntryTypeForBulk}
                                    onChange={(e) => setSelectedJournalEntryTypeForBulk(parseInt(e.target.value))}
                                    disableUnderline
                                    className="custom-input-box-sizing-toggle"
                                    sx={{
                                        height: '40px',
                                        padding: '0 8px',
                                        borderRadius: '6px',
                                        background: '#F5F5F6',
                                        border: '1px solid transparent',
                                        '&:focus-within': {
                                            border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                                        },
                                        textAlign: direction === 'ltr' ? 'right' : 'left',
                                    }}
                                    inputProps={{
                                        style: {
                                            textAlign: direction === 'ltr' ? 'right' : 'left',
                                        },
                                    }}
                                    MenuProps={{
                                        PaperProps: {
                                            style: {
                                                direction: direction,
                                            },
                                        },
                                    }}
                                >
                                    {JOURNAL_ENTRY_TYPE_OPTIONS.map((opt) => (
                                        <MenuItem key={opt.value} value={opt.value}>{t(opt.label)}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </DialogContent>
                    <DialogActions dir={direction} sx={{ justifyContent: 'center', paddingBottom: '20px' }}>
                        <Button
                            onClick={() => {
                                setIsEditJournalEntryTypeModalOpen(false);
                                setSelectedJournalEntryTypeForBulk(0); // Reset on cancel
                            }}
                            variant="outlined"
                            sx={{ marginRight: '8px' }}
                        >
                            {t('Cancel')}
                        </Button>
                        <Button
                            onClick={() => handleBulkUpdateJournalEntryType(selectedJournalEntryTypeForBulk)}
                            variant="contained"
                            sx={{ backgroundColor: '#304FFF' }}
                        >
                            {t('Save')}
                        </Button>
                    </DialogActions>
                </Dialog>

            </>
        </>

    );
}


export default JournalEntry;
